import React from "react";
import '../index.css';
import '../componentCSS/animatedImage.css';

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="freepik_stories-programming"
      className="animated"
      version="1.1"
      viewBox="0 0 500 500"
    >
      <g
        id="freepik--Floor--inject-17"
        className="animable"
        style={{
          WebkitTransformOrigin: 249.86,
          MsTransformOrigin: 249.86,
          transformOrigin: 249.86,
        }}
      >
        <ellipse
          id="freepik--floor--inject-17"
          cx="249.86"
          cy="362.36"
          fill="#F5F5F5"
          rx="224.23"
          ry="124.15"
          style={{
            WebkitTransformOrigin: 249.86,
            MsTransformOrigin: 249.86,
            transformOrigin: 249.86,
          }}
          className="animable"
        ></ellipse>
      </g>
      <g
        id="freepik--Shadows--inject-17"
        className="animable"
        style={{
          WebkitTransformOrigin: 269.298,
          MsTransformOrigin: 269.298,
          transformOrigin: 269.298,
        }}
      >
        <path
          id="freepik--Shadow--inject-17"
          d="M451.69 343.15l-125 72.2a3.69 3.69 0 01-3.36 0l-180.22-104a1 1 0 010-1.94l125-72.2a3.69 3.69 0 013.36 0l180.22 104a1 1 0 010 1.94z"
          style={{
            WebkitTransformOrigin: 297.4,
            MsTransformOrigin: 297.4,
            transformOrigin: 297.4,
          }}
          fill="#E6E6E6"
          className="animable"
        ></path>
        <ellipse
          id="freepik--shadow--inject-17"
          cx="161.23"
          cy="412.39"
          fill="#E6E6E6"
          rx="75.08"
          ry="43.35"
          style={{
            WebkitTransformOrigin: 161.23,
            MsTransformOrigin: 161.23,
            transformOrigin: 161.23,
          }}
          className="animable"
        ></ellipse>
        <ellipse
          id="freepik--shadow--inject-17"
          cx="252.65"
          cy="362.13"
          fill="#E6E6E6"
          rx="59.1"
          ry="34.12"
          style={{
            WebkitTransformOrigin: 252.65,
            MsTransformOrigin: 252.65,
            transformOrigin: 252.65,
          }}
          className="animable"
        ></ellipse>
        <ellipse
          id="freepik--shadow--inject-17"
          cx="384.09"
          cy="407.87"
          fill="#E6E6E6"
          rx="37.1"
          ry="21.42"
          style={{
            WebkitTransformOrigin: 384.09,
            MsTransformOrigin: 384.09,
            transformOrigin: 384.09,
          }}
          className="animable"
        ></ellipse>
      </g>
      <g
        id="freepik--Desk--inject-17"
        className="animable"
        style={{
          WebkitTransformOrigin: 308.085,
          MsTransformOrigin: 308.085,
          transformOrigin: 308.085,
        }}
      >
        <g
          id="freepik--desk--inject-17"
          className="animable"
          style={{
            WebkitTransformOrigin: 308.085,
            MsTransformOrigin: 308.085,
            transformOrigin: 308.085,
          }}
        >
          <g
            id="freepik--Table--inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 304.4,
              MsTransformOrigin: 304.4,
              transformOrigin: 304.4,
            }}
          >
            <path
              d="M329.42 286.36v111a2.48 2.48 0 01-1.12 1.94l-2.38 1.37a2.46 2.46 0 01-2.24 0l-2.38-1.37a2.48 2.48 0 01-1.12-1.94v-111c0-.71.5-1 1.12-.64l2.38 1.37a2.46 2.46 0 002.24 0l2.38-1.37c.62-.36 1.12-.07 1.12.64z"
              style={{
                WebkitTransformOrigin: 324.8,
                MsTransformOrigin: 324.8,
                transformOrigin: 324.8,
              }}
              id="el3l3dqujhbne"
              fill="#37474F"
              className="animable"
            ></path>
            <path
              d="M323.68 400.62l-2.38-1.37a2.48 2.48 0 01-1.12-1.94V286.36c0-.71.5-1 1.12-.64l2.38 1.37a2.48 2.48 0 011.12 1.91v111c0 .69-.5 1-1.12.62z"
              style={{
                WebkitTransformOrigin: 322.49,
                MsTransformOrigin: 322.49,
                transformOrigin: 322.49,
              }}
              id="elv06z2kq6uw"
              fill="#455A64"
              className="animable"
            ></path>
            <path
              d="M430.93 227.72v110.94a2.45 2.45 0 01-1.12 1.94l-2.38 1.4a2.52 2.52 0 01-2.24 0l-2.38-1.38a2.48 2.48 0 01-1.12-1.94V227.72c0-.71.51-1 1.12-.65l2.38 1.38a2.46 2.46 0 002.24 0l2.38-1.38c.62-.35 1.12-.07 1.12.65z"
              style={{
                WebkitTransformOrigin: 426.31,
                MsTransformOrigin: 426.31,
                transformOrigin: 426.31,
              }}
              id="eljkwvniqki4"
              fill="#37474F"
              className="animable"
            ></path>
            <path
              d="M425.19 342l-2.38-1.38a2.48 2.48 0 01-1.12-1.94V227.72c0-.71.51-1 1.12-.65l2.38 1.38a2.47 2.47 0 011.12 1.94v110.94c0 .67-.5 1-1.12.67z"
              style={{
                WebkitTransformOrigin: 424,
                MsTransformOrigin: 424,
                transformOrigin: 424,
              }}
              id="el6rjmoefgtx9"
              fill="#455A64"
              className="animable"
            ></path>
            <path
              d="M192.71 207.47v111a2.48 2.48 0 01-1.12 1.94l-2.38 1.37a2.46 2.46 0 01-2.24 0l-2.38-1.37a2.48 2.48 0 01-1.12-1.94v-111c0-.71.5-1 1.12-.64l2.41 1.37a2.46 2.46 0 002.24 0l2.38-1.37c.59-.36 1.09-.07 1.09.64z"
              style={{
                WebkitTransformOrigin: 188.09,
                MsTransformOrigin: 188.09,
                transformOrigin: 188.09,
              }}
              id="el1qhla910dau"
              fill="#37474F"
              className="animable"
            ></path>
            <path
              d="M187 321.73l-2.38-1.37a2.48 2.48 0 01-1.12-1.94v-111c0-.71.5-1 1.12-.64l2.38 1.42a2.48 2.48 0 011.12 1.94v110.94c-.03.72-.53 1.01-1.12.65z"
              style={{
                WebkitTransformOrigin: 185.81,
                MsTransformOrigin: 185.81,
                transformOrigin: 185.81,
              }}
              id="el4kofjd75n68"
              fill="#455A64"
              className="animable"
            ></path>
            <path
              d="M453 235.61v-.81a4.49 4.49 0 00-2-3.53L272 128a4.51 4.51 0 00-4.08 0L157.8 191.6a4.49 4.49 0 00-2 3.53v.87a4.49 4.49 0 002 3.53l179 103.26a4.58 4.58 0 004.08 0L451 239.14a4.49 4.49 0 002-3.53z"
              style={{
                WebkitTransformOrigin: 304.4,
                MsTransformOrigin: 304.4,
                transformOrigin: 304.4,
              }}
              id="ellmk5du2zawh"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M453 235.61v-.81a4.49 4.49 0 00-2-3.53L272 128a4.51 4.51 0 00-4.08 0L157.8 191.6a4.49 4.49 0 00-2 3.53v.87a4.49 4.49 0 002 3.53l179 103.26a4.58 4.58 0 004.08 0L451 239.14a4.49 4.49 0 002-3.53z"
              style={{
                WebkitTransformOrigin: 304.4,
                MsTransformOrigin: 304.4,
                transformOrigin: 304.4,
              }}
              id="eluxrji1h4b4"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M338.82 297.72v5.52a4.24 4.24 0 002-.49L451 239.15a4.51 4.51 0 002-3.53v-.82a4.53 4.53 0 00-1.66-3.26c.73.63.61 1.5-.38 2.09l-110.12 63.6a4.13 4.13 0 01-2.02.49z"
              style={{
                WebkitTransformOrigin: 395.91,
                MsTransformOrigin: 395.91,
                transformOrigin: 395.91,
              }}
              id="el65bulxte9w"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M338.82 297.72v5.52a4.24 4.24 0 002-.49L451 239.15a4.51 4.51 0 002-3.53v-.82a4.53 4.53 0 00-1.66-3.26c.73.63.61 1.5-.38 2.09l-110.12 63.6a4.13 4.13 0 01-2.02.49z"
              style={{
                WebkitTransformOrigin: 395.91,
                MsTransformOrigin: 395.91,
                transformOrigin: 395.91,
              }}
              id="el867itb9syo"
              className="animable"
              opacity="0.5"
            ></path>
            <path
              d="M451 233.62l-110.14 63.61a4.51 4.51 0 01-4.08 0L157.77 194a1.24 1.24 0 010-2.35L267.89 128a4.51 4.51 0 014.08 0L451 231.27a1.24 1.24 0 010 2.35z"
              style={{
                WebkitTransformOrigin: 304.385,
                MsTransformOrigin: 304.385,
                transformOrigin: 304.385,
              }}
              id="el4lolf76of4y"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M451 233.62l-110.14 63.61a4.51 4.51 0 01-4.08 0L157.77 194a1.24 1.24 0 010-2.35L267.89 128a4.51 4.51 0 014.08 0L451 231.27a1.24 1.24 0 010 2.35z"
              style={{
                WebkitTransformOrigin: 304.385,
                MsTransformOrigin: 304.385,
                transformOrigin: 304.385,
              }}
              id="elskq0vkutkg"
              className="animable"
              opacity="0.4"
            ></path>
          </g>
          <g
            id="freepik--Keyboard--inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 272.24,
              MsTransformOrigin: 272.24,
              transformOrigin: 272.24,
            }}
          >
            <path
              d="M325.29 232.24l-26.09 15.1a3.25 3.25 0 01-2.93 0l-77.08-44.44a.89.89 0 010-1.69l26.09-15.11a3.26 3.26 0 012.92 0l77.09 44.45a.89.89 0 010 1.69z"
              style={{
                WebkitTransformOrigin: 272.24,
                MsTransformOrigin: 272.24,
                transformOrigin: 272.24,
              }}
              id="freepik--shadow--inject-17"
              className="animable"
              opacity="0.15"
            ></path>
            <g
              id="freepik--keyboard--inject-17"
              className="animable"
              style={{
                WebkitTransformOrigin: 272.495,
                MsTransformOrigin: 272.495,
                transformOrigin: 272.495,
              }}
            >
              <path
                d="M220.77 198.53a1 1 0 01.61-.84l24.51-14.15a3.2 3.2 0 012.92 0l74.8 43.25a1 1 0 01.6.85v2.57a1 1 0 01-.6.84l-24.5 14.15a3.22 3.22 0 01-2.93 0l-74.8-43.2a1 1 0 01-.61-.84z"
                style={{
                  WebkitTransformOrigin: 272.49,
                  MsTransformOrigin: 272.49,
                  transformOrigin: 272.49,
                }}
                id="elo5h4l5hbqpa"
                fill="#263238"
                className="animable"
              ></path>
              <path
                d="M299.11 242.57l24.5-14.09a.89.89 0 000-1.69l-74.8-43.25a3.2 3.2 0 00-2.92 0l-24.51 14.15a.89.89 0 000 1.69l74.8 43.18a3.25 3.25 0 002.93.01z"
                style={{
                  WebkitTransformOrigin: 272.495,
                  MsTransformOrigin: 272.495,
                  transformOrigin: 272.495,
                }}
                id="elmcsx03aihmn"
                fill="#37474F"
                className="animable"
              ></path>
              <path
                d="M297.74 242.91v2.63a2.92 2.92 0 001.37-.34l24.49-14.14a1 1 0 00.61-.85v-2.58a1 1 0 01-.61.85l-24.49 14.09a3 3 0 01-1.37.34z"
                style={{
                  WebkitTransformOrigin: 310.975,
                  MsTransformOrigin: 310.975,
                  transformOrigin: 310.975,
                }}
                id="ellf8pojefubj"
                fill="#263238"
                className="animable"
              ></path>
              <path
                d="M225.31 198.72l2.42-1.4 3.29 1.9-2.44 1.45-3.29-1.9zm3.8-2.19l2.43-1.4 2.59 1.49-2.44 1.38-2.58-1.49zm.8 4.85l2.43-1.4 2.58 1.49-2.44 1.45-2.58-1.49zm3-7l2.43-1.4 4.17 2.42-2.44 1.44-4.17-2.41zm.09 4.44l2.42-1.41 2.06 1.19-2.43 1.4-2.05-1.21zm.8 4.84l2.42-1.4 2.59 1.49-2.45 1.45-2.58-1.49zm2.56-2.9l2.42-1.4 2 1.19-2.44 1.45-2-1.19zm.34-8.58l2.43-1.4 3.29 1.9-2.42 1.38-3.29-1.9zm1 13.73l2.42-1.4 18.68 10.78-2.44 1.45-18.68-10.78zm.7-8.37l2.42-1.4 2 1.19-2.44 1.44-2.05-1.18zm1.33 5.16l2.42-1.4 2.05 1.19-2.44 1.45-2.05-1.19zm.77-12.7l2.42-1.4 2.06 1.19-2.44 1.44-2.03-1.23zm.8 4.85l2.42-1.4 2.06 1.18-2.42 1.37-2.06-1.18zm.45 4.64l2.42-1.4 2.05 1.19-2.44 1.44-2.05-1.18zm1.33 5.16l2.42-1.4 2 1.19-2.44 1.45-2-1.19zm.78-12.71l2.42-1.4 2.06 1.19-2.44 1.44-2-1.18zm.8 4.85l2.42-1.4 2.06 1.18-2.44 1.45-2.05-1.18zm.45 4.64l2.42-1.4 2 1.19-2.44 1.44-2-1.18zm0-14.09l2.42-1.4 2.59 1.49-2.45 1.45-2.58-1.49zm1.33 19.25l2.42-1.4 2.05 1.19-2.44 1.45-2.05-1.19zm.78-12.71l2.42-1.4 2.06 1.19-2.42 1.33-2.05-1.18zm.8 4.85l2.42-1.4 2.06 1.18-2.44 1.45-2.06-1.26zm.45 4.64l2.42-1.4 2.05 1.19-2.44 1.44-2.05-1.18zm1.33 5.16l2.42-1.4 2 1.19-2.44 1.45-2-1.19zm.66-18.1l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm.12 5.39l2.42-1.4 2.06 1.19-2.43 1.39-2-1.18zm.8 4.85l2.42-1.4 2.06 1.18-2.44 1.45-2.05-1.18zm.45 4.64l2.42-1.4 2 1.19-2.44 1.44-2-1.18zm1.33 5.16l2.44-1.47 2 1.19-2.44 1.45-2.05-1.19zm.66-18.1l2.42-1.4 2.06 1.18-2.44 1.45-2-1.18zm.12 5.39l2.42-1.4 2.06 1.19-2.42 1.36-2-1.18zm.8 4.85l2.42-1.4 2.06 1.18-2.44 1.45-2.05-1.18zm.45 4.64l2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18zm1.33 5.16l2.42-1.41 2.05 1.19-2.44 1.45-2.05-1.19zm.66-18.1l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm.12 5.39l2.43-1.4 2.05 1.19-2.45 1.44-2-1.18zm.37 17.76l2.43-1.4 2.58 1.49-2.44 1.45-2.58-1.49zm.43-12.91l2.42-1.4 2.06 1.18-2.44 1.45-2.05-1.18zm.45 4.64l2.43-1.4 2.02 1.11-2.44 1.44-2.05-1.18zm1.33 5.16l2.42-1.4 2.06 1.19-2.45 1.45-2.05-1.19zm.66-18.1l2.43-1.4L265 196l-2.44 1.45-2.05-1.18zm.12 5.39l2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18zm.8 4.85l2.43-1.4 2 1.18-2.44 1.45-2-1.18zm.1 13.21l2.43-1.4 2.58 1.49-2.44 1.45-2.58-1.49zm.35-8.57l2.42-1.4 2 1.19-2.33 1.36-2-1.18zm1.33 5.16l2.42-1.4 2.06 1.19-2.45 1.45-2.05-1.19zm.78-12.71l2.43-1.4 2 1.19-2.44 1.44-2.01-1.26zm.8 4.85l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm.45 4.64l2.42-1.4 2.05 1.19-2.44 1.44-2.03-1.3zm.1-14l2.43-1.4 2.05 1.19-2.44 1.45-2.04-1.31zm.08 22.91l2.43-1.4 2.58 1.49-2.46 1.34-2.58-1.49zm1.15-3.72l2.42-1.41 2.06 1.19-2.45 1.45-2-1.19zm.78-12.71l2.42-1.4 2.06 1.19-2.44 1.44-2.05-1.18zm.8 4.85l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm.45 4.64l2.42-1.4 2.06 1.19-2.45 1.44-2.03-1.27zm.1-14l2.43-1.4 2.05 1.19-2.44 1.45-2-1.19zm.62 23.22l2.43-1.41 3.29 1.9-2.44 1.45-3.29-1.9zm.61-4l2.42-1.41 6.48 3.74-2.44 1.45-6.42-3.91zm.78-12.71l2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18zm.8 4.85l2.43-1.4 2.03 1-2.44 1.45-2.05-1.18zm.45 4.64l2.42-1.4 2.06 1.19-2.47 1.27-2-1.18zm.1-14l2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.19zm2 6.48l2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18zm.55 17.86l2.42-1.4 2.06 1.18-2.45 1.45-2-1.18zm.25-13l2.43-1.4 2 1.18-2.32 1.24-2-1.18zm.45 4.64l2.42-1.4 1.88 1.08a1.2 1.2 0 00.59.13 1.33 1.33 0 00.62-.13l3.19-1.84 2.4 1.39-6.23 3.64-4.89-2.82zm.1-14l2.43-1.4 2.05 1.19-2.42 1.19-2.05-1.19zm2 6.48l2.42-1.4 2.06 1.19-2.44 1.44-2-1.18zm.55 17.86l2.42-1.4 2.06 1.18-2.45 1.45-2-1.18zm.25-13l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm2-8.55l2.42-1.4 2.06 1.18-2.45 1.45-2.05-1.18zm.55 5.64l2.42-1.4 2.06 1.19-2.44 1.44-2.05-1.18zm.55 17.86l2.43-1.4 2.05 1.18-2.45 1.45-2-1.18zm.44-4.13l2.42-1.4 2.06 1.19-2.45 1.45-2-1.42zm1.82-17.43l2.42-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm.55 5.64l2.43-1.4 3.64 2.1-2.44 1.45-3.64-2.1zm1.26 18.27l2.42-1.4 5.42 3.12-2.45 1.45-5.41-3.12zm.6-12.81l2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18zm.95-9.16l2.42-1.4 2.05 1.18-2.43 1.2-2-1.18zm2.25 19.78l2.43-1.4 2.05 1.19-2.44 1.45-2.05-1.19zm.16-8.68l2.43-1.4 2 1.19-2.44 1.44-2-1.18zm.44-4.13l2.43-1.4 2 1.18-2.44 1.45-2-1.18zm.51-5l2.42-1.4 2 1.18-2.44 1.45-2-1.18zm1.81 23.91l2.42-1.4 2.06 1.18-2.45 1.45-2-1.18zm.44-4.13l2.43-1.4 2 1.19-2.44 1.45-2-1.19zm.16-8.68l2.43-1.4 2.05 1.19-2.44 1.44-2.05-1.18zm.28 4.54l2.43-1.4 2 1.19-2.44 1.44-2-1.18zm.16-8.67l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm1.25-4.6l2.42-1.4 2.06 1.18-2.39 1.19-2.05-1.18zm1.07 23.48l6.22-3.6 2.05 1.19-6.23 3.64-2.06-1.18zm.44-4.13l2.43-1.4 2.05 1.19-2.41 1.16-2-1.19zm.44-4.14l2.43-1.4 2.05 1.19-2.44 1.44-2.01-1.47zm.16-8.67l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm.27 4.54l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm1-9.14l2.42-1.4 2.06 1.18-2.44 1.45-2.05-1.18zm1.95 15.21l2.43-1.4 2.05 1.19-2.44 1.45-2.03-1.42zm.43-4.13l2.43-1.4 2.05 1.18-2.41 1.17-2.05-1.18zm.44-4.13l2.42-1.4 2.06 1.18-2.45 1.45-2-1.18zm.54-5l2.42-1.4 2.06 1.18-2.44 1.45-2.05-1.18zm1.95 15.21l6.23-3.59 2.05 1.18-6.24 3.65-2.05-1.19zm.43-4.13l2.43-1.4 2.05 1.18-2.44 1.45-2.05-1.18zm.44-4.13l2.42-1.4 2.06 1.18-2.46 1.16-2-1.18zm2.23-5.17l1-.61 2.06 1.19-1.06.65-2-1.18zm1.13 7.11l2.42-1.4 2.06 1.18-2.45 1.45-2-1.18zm2.23-5.17l1-.61 2.06 1.19-1.06.65-2-1.18zm1.13 7.11l2.42-1.4 2.06 1.18-2.45 1.45-2-1.18zm2.23-5.17l1-.61 2.06 1.19-1.06.65-2-1.18zm3.35 1.94l1-.61 2.06 1.19-1.06.65-2-1.18z"
                style={{
                  WebkitTransformOrigin: 272.315,
                  MsTransformOrigin: 272.315,
                  transformOrigin: 272.315,
                }}
                id="elllo5o21kt1"
                fill="#8AC832"
                className="animable"
              ></path>
            </g>
          </g>
          <g
            id="freepik--Device--inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 339.675,
              MsTransformOrigin: 339.675,
              transformOrigin: 339.675,
            }}
          >
            <path
              style={{
                WebkitTransformOrigin: 339.675,
                MsTransformOrigin: 339.675,
                transformOrigin: 339.675,
              }}
              id="freepik--shadow--inject-17"
              d="M385.58 235.17L408.53 221.92 293.77 155.66 270.82 168.91 385.58 235.17z"
              className="animable"
              opacity="0.15"
            ></path>
            <g
              id="freepik--Monitor--inject-17"
              className="animable"
              style={{
                WebkitTransformOrigin: 333.955,
                MsTransformOrigin: 333.955,
                transformOrigin: 333.955,
              }}
            >
              <path
                d="M320.59 213.6l-16.38-9.48c-1.69-1-2.54-2.25-2.54-3.53v-2.28l15.42-8.75a3.62 3.62 0 001.63-2.83v-20.2l28.62 16.54v20.2a3.62 3.62 0 01-1.63 2.83l-12.88 7.5a13.54 13.54 0 01-12.24 0z"
                style={{
                  WebkitTransformOrigin: 324.505,
                  MsTransformOrigin: 324.505,
                  transformOrigin: 324.505,
                }}
                id="elg37ty61yrqt"
                fill="#E6E6E6"
                className="animable"
              ></path>
              <path
                d="M340.47 206.85v2.27l5.24-3a3.6 3.6 0 001.63-2.83v-20.2l-5.45-3.15c-.11 1.39-.24 2.82-.35 4.21l3.82 2.22v15.78a3.57 3.57 0 01-1.63 2.83z"
                style={{
                  WebkitTransformOrigin: 343.905,
                  MsTransformOrigin: 343.905,
                  transformOrigin: 343.905,
                }}
                id="elbcd82gsmujp"
                fill="#E0E0E0"
                className="animable"
              ></path>
              <path
                d="M345.36 202.13a3.6 3.6 0 01-1.63 2.83l-10.9 6.36a13.54 13.54 0 01-12.24 0l-16.39-9.48c-3.38-1.94-3.38-5.11 0-7.06l10.91-6.36a3.6 3.6 0 001.63-2.82v-15.79l28.62 16.54z"
                style={{
                  WebkitTransformOrigin: 323.513,
                  MsTransformOrigin: 323.513,
                  transformOrigin: 323.513,
                }}
                id="el4oisxpvr819"
                fill="#F5F5F5"
                className="animable"
              ></path>
              <path
                d="M311.79 190.34l3.32-1.92a3.6 3.6 0 001.63-2.82v-15.79l28.62 16.54v15.78a3.6 3.6 0 01-1.63 2.83l-3.26 1.89z"
                style={{
                  WebkitTransformOrigin: 328.575,
                  MsTransformOrigin: 328.575,
                  transformOrigin: 328.575,
                }}
                id="el9ptd6dcirsm"
                fill="#EBEBEB"
                className="animable"
              ></path>
              <path
                d="M301.67 198.31v2.28c0 1.28.85 2.55 2.53 3.53l16.39 9.47a12.32 12.32 0 005.84 1.45v-2.27a12.32 12.32 0 01-5.84-1.45l-16.39-9.48c-1.68-.97-2.53-2.25-2.53-3.53z"
                style={{
                  WebkitTransformOrigin: 314.05,
                  MsTransformOrigin: 314.05,
                  transformOrigin: 314.05,
                }}
                id="el318vz7pniuv"
                fill="#EBEBEB"
                className="animable"
              ></path>
              <path
                d="M391.32 223.93a4.37 4.37 0 01-3.95-.07L276.68 160a4.49 4.49 0 01-2-3.53V59.54a3.83 3.83 0 015.87-3.39l110.68 63.91a4.49 4.49 0 012 3.53v96.88a4.36 4.36 0 01-1.91 3.46z"
                style={{
                  WebkitTransformOrigin: 333.954,
                  MsTransformOrigin: 333.954,
                  transformOrigin: 333.954,
                }}
                id="eli090j1hhbx"
                fill="#455A64"
                className="animable"
              ></path>
              <path
                d="M387.37 223.85L276.68 160a4.49 4.49 0 01-2-3.53V59.53c0-1.3.91-1.82 2-1.17l110.69 63.9a4.52 4.52 0 012 3.53v96.89c.04 1.32-.88 1.82-2 1.17z"
                style={{
                  WebkitTransformOrigin: 332.026,
                  MsTransformOrigin: 332.026,
                  transformOrigin: 332.026,
                }}
                id="elxpmypcvskvh"
                fill="#37474F"
                className="animable"
              ></path>
              <path
                d="M387.67 224.26a3.81 3.81 0 005.56-3.54v-10.9l-3.82 2.18v10.9c0 1.22-.75 1.75-1.74 1.36z"
                style={{
                  WebkitTransformOrigin: 390.452,
                  MsTransformOrigin: 390.452,
                  transformOrigin: 390.452,
                }}
                id="elfh8o4wbmwk"
                fill="#E0E0E0"
                className="animable"
              ></path>
              <path
                d="M389.41 212v10.9c0 1.3-.92 1.83-2 1.18L276.68 160.2a4.49 4.49 0 01-2-3.53v-10.9z"
                style={{
                  WebkitTransformOrigin: 332.045,
                  MsTransformOrigin: 332.045,
                  transformOrigin: 332.045,
                }}
                id="elei90yvlm4od"
                fill="#FFF"
                className="animable"
              ></path>
              <path
                d="M385.58 203.74v-76.68a2.72 2.72 0 00-1.22-2.12L279.69 64.52c-.67-.39-1.22-.08-1.22.7v76.68a2.69 2.69 0 001.22 2.12l104.67 60.43c.64.39 1.22.07 1.22-.71z"
                style={{
                  WebkitTransformOrigin: 332.025,
                  MsTransformOrigin: 332.025,
                  transformOrigin: 332.025,
                }}
                id="elpzz6vtiixms"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M385.58 203.74v-76.68a2.72 2.72 0 00-1.22-2.12L279.69 64.52c-.67-.39-1.22-.08-1.22.7v76.68a2.69 2.69 0 001.22 2.12l104.67 60.43c.64.39 1.22.07 1.22-.71z"
                style={{
                  WebkitTransformOrigin: 332.025,
                  MsTransformOrigin: 332.025,
                  transformOrigin: 332.025,
                }}
                id="ell2k4nyb0tsr"
                fill="#FFF"
                className="animable"
                opacity="0.5"
              ></path>
              <path
                d="M332 183.07a4.24 4.24 0 011.91 3.31c0 1.22-.86 1.72-1.91 1.11a4.24 4.24 0 01-1.92-3.32c.03-1.17.92-1.71 1.92-1.1z"
                style={{
                  WebkitTransformOrigin: 331.995,
                  MsTransformOrigin: 331.995,
                  transformOrigin: 331.995,
                }}
                id="elmgzkgkw3lzg"
                fill="#455A64"
                className="animable"
              ></path>
              <path
                d="M388.81 123.78a4.4 4.4 0 01.6 2V212l3.82-2.21v-86.2a4.2 4.2 0 00-.6-2z"
                style={{
                  WebkitTransformOrigin: 391.02,
                  MsTransformOrigin: 391.02,
                  transformOrigin: 391.02,
                }}
                id="elva1exgrl49m"
                fill="#263238"
                className="animable"
              ></path>
            </g>
          </g>
          <g
            id="freepik--Window--inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 360.53,
              MsTransformOrigin: 360.53,
              transformOrigin: 360.53,
            }}
          >
            <g
              id="freepik--window--inject-17"
              className="animable"
              style={{
                WebkitTransformOrigin: 360.53,
                MsTransformOrigin: 360.53,
                transformOrigin: 360.53,
              }}
            >
              <path
                d="M292.75 39.53a1.13 1.13 0 010-.18.84.84 0 010-.17.8.8 0 01.11-.25.33.33 0 01.06-.1l.06-.07a.8.8 0 01.13-.13 1 1 0 01.17-.1 1.43 1.43 0 011.31.17l129.18 74.54a4.35 4.35 0 011.95 3.39v93.92a1.33 1.33 0 01-.7 1.17l-.09.06-.1.06h-.17a1 1 0 01-.25 0 1.29 1.29 0 01-.64-.19h-.05L422 210.6l-127.31-73.48a4.32 4.32 0 01-1.95-3.38v-94c0-.05.01-.13.01-.21z"
                style={{
                  WebkitTransformOrigin: 359.23,
                  MsTransformOrigin: 359.23,
                  transformOrigin: 359.23,
                }}
                id="elnvdykmpih7s"
                fill="#455A64"
                className="animable"
              ></path>
              <path
                d="M293.38 38.48a1.43 1.43 0 011.31.17l129.18 74.54a4.35 4.35 0 011.95 3.39V123l2.49-1.46v-6.33a4.32 4.32 0 00-1.95-3.38L297.18 37.24a1.36 1.36 0 00-1.41-.12c-.35.22-1.97 1.14-2.39 1.36z"
                style={{
                  WebkitTransformOrigin: 360.845,
                  MsTransformOrigin: 360.845,
                  transformOrigin: 360.845,
                }}
                id="elisduvovdz1"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M292.74 39.76c0-1.23.88-1.73 1.95-1.11l129.18 74.55a4.29 4.29 0 011.95 3.38V123L292.74 46.17z"
                style={{
                  WebkitTransformOrigin: 359.28,
                  MsTransformOrigin: 359.28,
                  transformOrigin: 359.28,
                }}
                id="el7xcz4v3a78t"
                fill="#8AC832"
                className="animable"
              ></path>
              <g
                style={{
                  WebkitTransformOrigin: 360.555,
                  MsTransformOrigin: 360.555,
                  transformOrigin: 360.555,
                }}
                id="ela4tmnwvnp7n"
                className="animable"
                opacity="0.5"
              >
                <path
                  d="M294.69 38.65l129.18 74.55a4 4 0 011.37 1.44l2.48-1.43a3.91 3.91 0 00-1.36-1.43L297.19 37.24a1.38 1.38 0 00-1.42-.12c-.35.22-2 1.14-2.38 1.36a1.38 1.38 0 011.3.17z"
                  style={{
                    WebkitTransformOrigin: 360.555,
                    MsTransformOrigin: 360.555,
                    transformOrigin: 360.555,
                  }}
                  id="elf2toa6y4nta"
                  fill="#FFF"
                  className="animable"
                ></path>
              </g>
              <path
                d="M428.32 121.5v-6.34a4 4 0 00-.59-2l-2.49 1.43a3.84 3.84 0 01.59 1.94V123z"
                style={{
                  WebkitTransformOrigin: 426.78,
                  MsTransformOrigin: 426.78,
                  transformOrigin: 426.78,
                }}
                id="el6jfpcrfa96l"
                className="animable"
                opacity="0.15"
              ></path>
              <path
                d="M421.42 114.54a2.91 2.91 0 011.1 2.34c0 .93-.49 1.41-1.1 1.06a2.91 2.91 0 01-1.1-2.34c0-.93.49-1.41 1.1-1.06z"
                style={{
                  WebkitTransformOrigin: 421.42,
                  MsTransformOrigin: 421.42,
                  transformOrigin: 421.42,
                }}
                id="ely83r57h3io"
                fill="#455A64"
                className="animable"
              ></path>
              <path
                d="M417.45 112.25a2.89 2.89 0 011.1 2.33c0 .94-.49 1.41-1.1 1.06a2.89 2.89 0 01-1.1-2.33c0-.94.49-1.41 1.1-1.06z"
                style={{
                  WebkitTransformOrigin: 417.45,
                  MsTransformOrigin: 417.45,
                  transformOrigin: 417.45,
                }}
                id="elfluq0m1fdy"
                fill="#455A64"
                className="animable"
              ></path>
              <path
                d="M413.48 110a2.91 2.91 0 011.1 2.34c0 .93-.49 1.41-1.1 1.06a2.92 2.92 0 01-1.1-2.34c0-.99.49-1.46 1.1-1.06z"
                style={{
                  WebkitTransformOrigin: 413.48,
                  MsTransformOrigin: 413.48,
                  transformOrigin: 413.48,
                }}
                id="el34h2bczdc1n"
                fill="#455A64"
                className="animable"
              ></path>
              <path
                d="M425.12 211.69l.1-.06 2.06-1.19a2.06 2.06 0 001-1.51 2.64 2.64 0 000-.28v-87.16l-2.5 1.47v87.55a1.29 1.29 0 01-.61 1.11h-.06z"
                style={{
                  WebkitTransformOrigin: 426.697,
                  MsTransformOrigin: 426.697,
                  transformOrigin: 426.697,
                }}
                id="elnwyxhomqle"
                fill="#263238"
                className="animable"
                opacity="0.9"
              ></path>
            </g>
            <g
              id="freepik--Code--inject-17"
              className="animable"
              style={{
                WebkitTransformOrigin: 356.68,
                MsTransformOrigin: 356.68,
                transformOrigin: 356.68,
              }}
            >
              <path
                d="M332.31 79.44l27.23 15.69a1.48 1.48 0 01.7 1.15c0 .42-.31.58-.7.35l-27.23-15.69a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 345.93,
                  MsTransformOrigin: 345.93,
                  transformOrigin: 345.93,
                }}
                id="el8i4zizc8w7x"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M342.72 109.48l10.28 5.94a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35L342.72 111a1.46 1.46 0 01-.7-1.15c-.02-.43.31-.59.7-.37z"
                style={{
                  WebkitTransformOrigin: 347.855,
                  MsTransformOrigin: 347.855,
                  transformOrigin: 347.855,
                }}
                id="el3dkuts45kie"
                fill="#E6E6E6"
                className="animable"
              ></path>
              <path
                d="M342.72 115.49l10.28 5.93a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35L342.72 117a1.48 1.48 0 01-.7-1.15c-.02-.43.31-.58.7-.36z"
                style={{
                  WebkitTransformOrigin: 347.855,
                  MsTransformOrigin: 347.855,
                  transformOrigin: 347.855,
                }}
                id="eldyb3ozloxg9"
                fill="#E6E6E6"
                className="animable"
              ></path>
              <path
                d="M362.23 96.68l54.53 31.4a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35l-54.53-31.4a1.51 1.51 0 01-.69-1.16c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 389.495,
                  MsTransformOrigin: 389.495,
                  transformOrigin: 389.495,
                }}
                id="el62g5z4ldc4m"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M342.94 151.61l16.6 9.61a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-16.6-9.61a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 351.245,
                  MsTransformOrigin: 351.245,
                  transformOrigin: 351.245,
                }}
                id="elqb5ta6e3f2"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M362.23 162.77l54.53 31.44a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-54.53-31.44a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 389.495,
                  MsTransformOrigin: 389.495,
                  transformOrigin: 389.495,
                }}
                id="elw8ia8lhc08f"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M332.31 85.46L346 93.34a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.35L332.31 87a1.48 1.48 0 01-.69-1.15c0-.45.31-.61.69-.39z"
                style={{
                  WebkitTransformOrigin: 339.155,
                  MsTransformOrigin: 339.155,
                  transformOrigin: 339.155,
                }}
                id="elcjftvyjfzi6"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M332.31 85.46L346 93.34a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.35L332.31 87a1.48 1.48 0 01-.69-1.15c0-.45.31-.61.69-.39z"
                style={{
                  WebkitTransformOrigin: 339.155,
                  MsTransformOrigin: 339.155,
                  transformOrigin: 339.155,
                }}
                id="ellaxfviwrgg"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M332.31 91.46l6.42 3.7a1.49 1.49 0 01.69 1.15c0 .41-.31.57-.69.35L332.31 93a1.49 1.49 0 01-.69-1.15c0-.46.31-.61.69-.39z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="eld76ahp9kge"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M332.31 91.46l6.42 3.7a1.49 1.49 0 01.69 1.15c0 .41-.31.57-.69.35L332.31 93a1.49 1.49 0 01-.69-1.15c0-.46.31-.61.69-.39z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="el1j1h06s141h"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M332.31 103.47l6.42 3.7a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35l-6.42-3.7a1.51 1.51 0 01-.69-1.16c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="eleyr1csygl2a"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M332.31 103.47l6.42 3.7a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35l-6.42-3.7a1.51 1.51 0 01-.69-1.16c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="elpqop4qvwjbf"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M332.31 109.48l6.42 3.7a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.35l-6.42-3.7a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="elqgktabdkf0n"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M332.31 109.48l6.42 3.7a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.35l-6.42-3.7a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="elo120eifdp6l"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M348.72 94.89l8.22 4.77a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35l-8.22-4.76a1.5 1.5 0 01-.7-1.16c-.02-.41.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 352.83,
                  MsTransformOrigin: 352.83,
                  transformOrigin: 352.83,
                }}
                id="ele0dok3nuufn"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M348.72 94.89l8.22 4.77a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35l-8.22-4.76a1.5 1.5 0 01-.7-1.16c-.02-.41.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 352.83,
                  MsTransformOrigin: 352.83,
                  transformOrigin: 352.83,
                }}
                id="elp9cdwrek68"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M361.44 138.33l55.32 31.85a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-55.32-31.85a1.48 1.48 0 01-.7-1.15c0-.42.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 389.095,
                  MsTransformOrigin: 389.095,
                  transformOrigin: 389.095,
                }}
                id="elbc3jmo01km7"
                fill="#FFF"
                className="animable"
              ></path>
              <path
                d="M408.53 159.4l8.23 4.76a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-8.23-4.76a1.49 1.49 0 01-.69-1.15c0-.42.31-.58.69-.35z"
                style={{
                  WebkitTransformOrigin: 412.645,
                  MsTransformOrigin: 412.645,
                  transformOrigin: 412.645,
                }}
                id="eler2weknjw6l"
                fill="#FFF"
                className="animable"
              ></path>
              <path
                d="M350.52 126l55.32 31.85a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35l-55.32-31.86a1.5 1.5 0 01-.69-1.16c0-.41.31-.57.69-.34z"
                style={{
                  WebkitTransformOrigin: 378.18,
                  MsTransformOrigin: 378.18,
                  transformOrigin: 378.18,
                }}
                id="el8e0svlaagxw"
                fill="#FFF"
                className="animable"
              ></path>
              <path
                d="M342.72 97.47l13.71 7.88a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L342.72 99a1.48 1.48 0 01-.7-1.15c-.02-.45.31-.61.7-.38z"
                style={{
                  WebkitTransformOrigin: 349.575,
                  MsTransformOrigin: 349.575,
                  transformOrigin: 349.575,
                }}
                id="eloeou7dxvaa"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M342.72 97.47l13.71 7.88a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L342.72 99a1.48 1.48 0 01-.7-1.15c-.02-.45.31-.61.7-.38z"
                style={{
                  WebkitTransformOrigin: 349.575,
                  MsTransformOrigin: 349.575,
                  transformOrigin: 349.575,
                }}
                id="elxnqhq1shhva"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M359.12 106.9l57.23 33.1a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35l-57.23-33.11a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 387.735,
                  MsTransformOrigin: 387.735,
                  transformOrigin: 387.735,
                }}
                id="elywd9ey9jvnd"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M359.12 106.9l57.23 33.1a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35l-57.23-33.11a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 387.735,
                  MsTransformOrigin: 387.735,
                  transformOrigin: 387.735,
                }}
                id="el8ojhhf47sfn"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M342.72 133.64l74 42.69a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.36l-74-42.7A1.48 1.48 0 01342 134c0-.43.33-.58.72-.36z"
                style={{
                  WebkitTransformOrigin: 379.705,
                  MsTransformOrigin: 379.705,
                  transformOrigin: 379.705,
                }}
                id="elzfz7ktl4qyf"
                fill="#E6E6E6"
                className="animable"
              ></path>
              <path
                d="M332.31 127.63l6.42 3.7a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-6.42-3.7a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="elil819yu5zhg"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M332.31 127.63l6.42 3.7a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-6.42-3.7a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="el2nsppos6qsx"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M342.72 139.64l74 42.7a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-74-42.7A1.46 1.46 0 01342 140c0-.42.33-.58.72-.36z"
                style={{
                  WebkitTransformOrigin: 379.705,
                  MsTransformOrigin: 379.705,
                  transformOrigin: 379.705,
                }}
                id="el8oe865ejisd"
                fill="#E6E6E6"
                className="animable"
              ></path>
              <path
                d="M332.31 133.64l6.42 3.7a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-6.42-3.7a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="elnhe08itliar"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M332.31 133.64l6.42 3.7a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-6.42-3.7a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="el1ta2jficu3v"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M342.72 145.65l74 42.7a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-74-42.7A1.48 1.48 0 01342 146c0-.42.33-.57.72-.35z"
                style={{
                  WebkitTransformOrigin: 379.705,
                  MsTransformOrigin: 379.705,
                  transformOrigin: 379.705,
                }}
                id="el9fx0ukbp3nr"
                fill="#E6E6E6"
                className="animable"
              ></path>
              <path
                d="M332.31 139.64l6.42 3.7a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.36l-6.42-3.71a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="el37opkkxnbj4"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M332.31 139.64l6.42 3.7a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.36l-6.42-3.71a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 335.52,
                  MsTransformOrigin: 335.52,
                  transformOrigin: 335.52,
                }}
                id="el6mo5d8rvhrx"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <g
                style={{
                  WebkitTransformOrigin: 324.19,
                  MsTransformOrigin: 324.19,
                  transformOrigin: 324.19,
                }}
                id="el8tb2mfoy77"
                className="animable"
                opacity="0.6"
              >
                <path
                  d="M322.31 73.41l3.77 2.18a1.51 1.51 0 01.68 1.19v1.39c0 .43-.3.61-.68.39l-3.77-2.18a1.5 1.5 0 01-.69-1.18v-1.39c0-.44.31-.61.69-.4z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elqxiz4d5jufo"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 79.48l3.77 2.18a1.51 1.51 0 01.68 1.18v1.39c0 .44-.3.61-.68.4l-3.77-2.18a1.52 1.52 0 01-.69-1.19v-1.39c0-.43.31-.61.69-.39z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elxwol70azgls"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 85.54l3.77 2.18a1.51 1.51 0 01.68 1.19v1.39c0 .43-.3.61-.68.39l-3.77-2.18a1.52 1.52 0 01-.69-1.18v-1.39c0-.44.31-.61.69-.4z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elsecli4tthxk"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 91.61l3.77 2.18a1.51 1.51 0 01.68 1.18v1.39c0 .44-.3.61-.68.4l-3.77-2.18a1.52 1.52 0 01-.69-1.19V92c0-.43.31-.61.69-.39z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elpolam29qfy"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 97.67l3.77 2.18a1.51 1.51 0 01.68 1.19v1.38c0 .44-.3.62-.68.4l-3.77-2.18a1.52 1.52 0 01-.69-1.18v-1.39c0-.44.31-.62.69-.4z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="eljnxolmh2nx"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 103.74l3.77 2.18a1.49 1.49 0 01.68 1.18v1.39c0 .44-.3.61-.68.4l-3.77-2.18a1.52 1.52 0 01-.69-1.19v-1.39c0-.43.31-.61.69-.39z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elutvmpygmnrl"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 109.8l3.77 2.18a1.51 1.51 0 01.68 1.19v1.38c0 .44-.3.62-.68.4l-3.77-2.18a1.52 1.52 0 01-.69-1.18v-1.39c0-.44.31-.62.69-.4z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elypgk3mr84g"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 115.87l3.77 2.18a1.49 1.49 0 01.68 1.18v1.39c0 .44-.3.61-.68.39l-3.77-2.17a1.52 1.52 0 01-.69-1.19v-1.39c0-.43.31-.61.69-.39z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="eluerx2137cca"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 121.93l3.77 2.18a1.51 1.51 0 01.68 1.19v1.38c0 .44-.3.62-.68.4l-3.77-2.18a1.52 1.52 0 01-.69-1.19v-1.38c0-.44.31-.62.69-.4z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elozoxtwss3jg"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 128l3.77 2.18a1.48 1.48 0 01.68 1.18v1.39c0 .44-.3.61-.68.39l-3.77-2.14a1.52 1.52 0 01-.69-1.19v-1.39c0-.42.31-.64.69-.42z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elnxtrb505fyp"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 134.06l3.77 2.18a1.51 1.51 0 01.68 1.19v1.38c0 .44-.3.62-.68.4l-3.77-2.21a1.52 1.52 0 01-.69-1.19v-1.38c0-.43.31-.59.69-.37z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elwfny7gnjz3"
                  fill="#FFF"
                  className="animable"
                ></path>
                <path
                  d="M322.31 140.13l3.77 2.17a1.51 1.51 0 01.68 1.19v1.39c0 .44-.3.61-.68.39l-3.77-2.17a1.52 1.52 0 01-.69-1.19v-1.39c0-.43.31-.61.69-.39z"
                  style={{
                    WebkitTransformOrigin: 324.19,
                    MsTransformOrigin: 324.19,
                    transformOrigin: 324.19,
                  }}
                  id="elwkgz62ik25"
                  fill="#FFF"
                  className="animable"
                ></path>
              </g>
              <path
                d="M297.28 53.71l20.4 11.78a3 3 0 011.37 2.37v23.56c0 .87-.61 1.23-1.37.79l-20.4-11.78a3 3 0 01-1.37-2.37V54.51c0-.88.61-1.23 1.37-.8z"
                style={{
                  WebkitTransformOrigin: 307.48,
                  MsTransformOrigin: 307.48,
                  transformOrigin: 307.48,
                }}
                id="elfml1fjgk0ng"
                fill="#37474F"
                className="animable"
              ></path>
              <path
                d="M299.17 77.06l1.88 1.09a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="eldl11eppl5x"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M299.17 77.06l1.88 1.09a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="eli95mhtu4ybm"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M299.17 57.77l1.88 1.09a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.08a1.51 1.51 0 01-.69-1.16c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="elwv5auhkbns"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M299.17 57.77l1.88 1.09a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.08a1.51 1.51 0 01-.69-1.16c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="el0ddv8yrst57d"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M301.81 63.15l1.88 1.08a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elr0kph2vbgx"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 63.15l1.88 1.08a1.49 1.49 0 01.69 1.15c0 .42-.31.58-.69.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="eluzn3e05e4wi"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M301.81 67l1.88 1.09a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.43.31-.59.69-.36z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="ell6xqijzpr9"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 67l1.88 1.09a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.43.31-.59.69-.36z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="el6xwedrsosgo"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M299.17 69.34l1.88 1.09a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.08a1.5 1.5 0 01-.69-1.16c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="eln986lmsglz"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M299.17 69.34l1.88 1.09a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.08a1.5 1.5 0 01-.69-1.16c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="eld3v8hz9f"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M301.81 74.72l1.88 1.09a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elefmh9v2hzec"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 74.72l1.88 1.09a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="eloeagjg0bvj"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M304.32 60.74l11.46 6.63a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.48 1.48 0 01-.7-1.16c0-.41.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elaoessz1aoym"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M304.32 60.74l11.46 6.63a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.48 1.48 0 01-.7-1.16c0-.41.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="el3dqfqoyq4be"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M304.32 80l11.46 6.63a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.5 1.5 0 01-.7-1.16c0-.35.31-.54.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="eldg8o1dbr6on"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M304.32 80l11.46 6.63a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.5 1.5 0 01-.7-1.16c0-.35.31-.54.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elqpg1d8k532s"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M307 66.12l8.82 5.1a1.48 1.48 0 01.7 1.16c0 .41-.31.57-.7.35L307 67.62a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="el74rxhzqlv3b"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 66.12l8.82 5.1a1.48 1.48 0 01.7 1.16c0 .41-.31.57-.7.35L307 67.62a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="ellnrlp0e931"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M307 70l8.82 5.11a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35L307 71.48a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.58.7-.33z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elxfbr7kg07qn"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 70l8.82 5.11a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35L307 71.48a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.58.7-.33z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elkolis0t1jpn"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M304.32 72.32l11.46 6.62a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35l-11.46-6.62a1.48 1.48 0 01-.7-1.15c0-.42.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elwebyzb2exmb"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M304.32 72.32l11.46 6.62a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35l-11.46-6.62a1.48 1.48 0 01-.7-1.15c0-.42.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elgi7j67qtqst"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M307 77.69l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L307 79.19a1.46 1.46 0 01-.7-1.15c-.04-.41.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="eljihdgiywkb"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 77.69l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L307 79.19a1.46 1.46 0 01-.7-1.15c-.04-.41.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="eln9h8myhcu1"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M297.28 84.87l20.4 11.77a3 3 0 011.37 2.36v46.54c0 .88-.61 1.23-1.37.79l-20.4-11.78a3 3 0 01-1.37-2.37V85.66c0-.88.61-1.23 1.37-.79z"
                style={{
                  WebkitTransformOrigin: 307.48,
                  MsTransformOrigin: 307.48,
                  transformOrigin: 307.48,
                }}
                id="elodw3ca0cav"
                fill="#37474F"
                className="animable"
              ></path>
              <path
                d="M299.17 88.92l1.88 1.08a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="elg6gdvy118aq"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M299.17 88.92l1.88 1.08a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="el2fh00t4zv37"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M301.81 94.3l1.88 1.08a1.5 1.5 0 01.69 1.16c0 .41-.31.57-.69.35l-1.88-1.09a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elwewwm58ixu"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 94.3l1.88 1.08a1.5 1.5 0 01.69 1.16c0 .41-.31.57-.69.35l-1.88-1.09a1.49 1.49 0 01-.69-1.15c0-.42.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elqc5nt3f4am8"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M301.81 98.15l1.88 1.08a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.42.31-.58.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elz4gk0wjb359"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 98.15l1.88 1.08a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.42.31-.58.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elq2ow3wwr4d8"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M299.17 100.5l1.88 1.08a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.42.31-.58.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="el4shkeodoedk"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M299.17 100.5l1.88 1.08a1.51 1.51 0 01.7 1.15c0 .42-.32.57-.7.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.42.31-.58.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="el12h2ymjkljm"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M304.32 91.9l11.46 6.62a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.48 1.48 0 01-.7-1.15c0-.42.31-.58.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="el9bgl8evfu2v"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M304.32 91.9l11.46 6.62a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.48 1.48 0 01-.7-1.15c0-.42.31-.58.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elboprzni86yd"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M307 97.27l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L307 98.77a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elqvkhgj7xfu"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 97.27l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L307 98.77a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="el6bjq5wnaa47"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M307 101.13l8.82 5.1a1.48 1.48 0 01.7 1.15c0 .42-.31.58-.7.36l-8.82-5.11a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.58.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="el2189d4mzx88"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 101.13l8.82 5.1a1.48 1.48 0 01.7 1.15c0 .42-.31.58-.7.36l-8.82-5.11a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.58.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="el8v9wpsz1bjh"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M304.32 103.47l11.46 6.62a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35L304.32 105a1.48 1.48 0 01-.7-1.15c0-.45.31-.6.7-.38z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elunxnu4xk6b"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M304.32 103.47l11.46 6.62a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35L304.32 105a1.48 1.48 0 01-.7-1.15c0-.45.31-.6.7-.38z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elrnljbjg2zqt"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M301.81 105.89l1.88 1.09a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.42.31-.58.69-.36z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="el4t514pb02ol"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 105.89l1.88 1.09a1.49 1.49 0 01.69 1.15c0 .42-.31.57-.69.35l-1.88-1.08a1.49 1.49 0 01-.69-1.15c0-.42.31-.58.69-.36z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elf6xekgj6l3u"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M301.81 109.74l1.88 1.09a1.49 1.49 0 01.69 1.15c0 .41-.31.57-.69.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elmnd10vs5u2r"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 109.74l1.88 1.09a1.49 1.49 0 01.69 1.15c0 .41-.31.57-.69.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="el7ktnsef15wf"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M307 108.86l8.82 5.11a1.48 1.48 0 01.7 1.15c0 .42-.31.58-.7.35l-8.82-5.1a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.58.7-.36z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="eld2qvgjyhji5"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 108.86l8.82 5.11a1.48 1.48 0 01.7 1.15c0 .42-.31.58-.7.35l-8.82-5.1a1.48 1.48 0 01-.7-1.15c-.04-.42.27-.58.7-.36z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elyrzkznz8n8d"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M307 112.72l8.82 5.11a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35l-8.82-5.11a1.46 1.46 0 01-.7-1.15c-.04-.41.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elvhfpgt4siyb"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 112.72l8.82 5.11a1.48 1.48 0 01.7 1.15c0 .42-.31.57-.7.35l-8.82-5.11a1.46 1.46 0 01-.7-1.15c-.04-.41.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="eli7jxrvj344"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M299.17 119.83l1.88 1.09a1.49 1.49 0 01.7 1.15c0 .41-.32.57-.7.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="eln02nm76so2o"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M299.17 119.83l1.88 1.09a1.49 1.49 0 01.7 1.15c0 .41-.32.57-.7.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="elwp08f70khfg"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M304.32 122.8l11.46 6.63a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.48 1.48 0 01-.7-1.15c0-.42.31-.58.7-.36z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="ellcp3sra2qs"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M304.32 122.8l11.46 6.63a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.48 1.48 0 01-.7-1.15c0-.42.31-.58.7-.36z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elqjlpdufm1i"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M301.81 125.23l1.88 1.09a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.58.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elyopkncnc6a"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 125.23l1.88 1.09a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.58.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="eltppdqkawlll"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M301.81 129.08l1.88 1.08a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35l-1.88-1.09a1.49 1.49 0 01-.69-1.15c0-.43.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="el8rv5j40pm"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 129.08l1.88 1.08a1.51 1.51 0 01.69 1.16c0 .41-.31.57-.69.35l-1.88-1.09a1.49 1.49 0 01-.69-1.15c0-.43.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elmur2whpoi29"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M307 128.2l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L307 129.7a1.46 1.46 0 01-.7-1.15c-.04-.41.27-.55.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elxfrgnuxd8a"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 128.2l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L307 129.7a1.46 1.46 0 01-.7-1.15c-.04-.41.27-.55.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elw29oymoybz"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M307 132.06l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-8.82-5.11a1.48 1.48 0 01-.7-1.15c-.04-.41.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elotuqbdlb51"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 132.06l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-8.82-5.11a1.48 1.48 0 01-.7-1.15c-.04-.41.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elzl6x35bxloh"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M301.81 113.57l1.88 1.09a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elh07hx9g7msc"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M301.81 113.57l1.88 1.09a1.48 1.48 0 01.69 1.15c0 .41-.31.57-.69.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 302.75,
                  MsTransformOrigin: 302.75,
                  transformOrigin: 302.75,
                }}
                id="elym0ru2swgy"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M299.17 115.92l1.88 1.09a1.49 1.49 0 01.7 1.15c0 .41-.32.57-.7.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="eld7tz3plg2d"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M299.17 115.92l1.88 1.09a1.49 1.49 0 01.7 1.15c0 .41-.32.57-.7.35l-1.88-1.09a1.48 1.48 0 01-.69-1.15c0-.41.31-.57.69-.35z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="elxeq3ifp35u"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M307 116.55l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-8.82-5.11a1.46 1.46 0 01-.7-1.15c-.04-.41.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="elpq3kpl4e18"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M307 116.55l8.82 5.11a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-8.82-5.11a1.46 1.46 0 01-.7-1.15c-.04-.41.27-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 311.408,
                  MsTransformOrigin: 311.408,
                  transformOrigin: 311.408,
                }}
                id="eldoe5zofwey5"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M304.32 118.89l11.46 6.63a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.5 1.5 0 01-.7-1.16c0-.41.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="el7bzg92b8uyw"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M304.32 118.89l11.46 6.63a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35l-11.46-6.62a1.5 1.5 0 01-.7-1.16c0-.41.31-.57.7-.35z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="eljouxbuowthc"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
              <path
                d="M299.17 131.48l1.88 1.09a1.49 1.49 0 01.7 1.15c0 .41-.32.57-.7.35l-1.88-1.07a1.48 1.48 0 01-.69-1.15c0-.43.31-.59.69-.37z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="el2m4cig1242a"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M299.17 131.48l1.88 1.09a1.49 1.49 0 01.7 1.15c0 .41-.32.57-.7.35l-1.88-1.07a1.48 1.48 0 01-.69-1.15c0-.43.31-.59.69-.37z"
                style={{
                  WebkitTransformOrigin: 300.115,
                  MsTransformOrigin: 300.115,
                  transformOrigin: 300.115,
                }}
                id="el0clmjhpojt4r"
                fill="#FFF"
                className="animable"
                opacity="0.6"
              ></path>
              <path
                d="M304.32 134.46l11.46 6.62a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L304.32 136a1.48 1.48 0 01-.7-1.15c0-.46.31-.62.7-.39z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elxje09uvkwyo"
                fill="#8AC832"
                className="animable"
              ></path>
              <path
                d="M304.32 134.46l11.46 6.62a1.46 1.46 0 01.7 1.15c0 .41-.31.57-.7.35L304.32 136a1.48 1.48 0 01-.7-1.15c0-.46.31-.62.7-.39z"
                style={{
                  WebkitTransformOrigin: 310.05,
                  MsTransformOrigin: 310.05,
                  transformOrigin: 310.05,
                }}
                id="elzfusyt8jfik"
                fill="#FFF"
                className="animable"
                opacity="0.8"
              ></path>
            </g>
          </g>
          <g
            id="freepik--window--inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 435.575,
              MsTransformOrigin: 435.575,
              transformOrigin: 435.575,
            }}
          >
            <g
              style={{
                WebkitTransformOrigin: 434.31,
                MsTransformOrigin: 434.31,
                transformOrigin: 434.31,
              }}
              id="eli7jxctg3ba"
              className="animable"
              opacity="0.8"
            >
              <path
                d="M410.78 150.29v76.38a3.51 3.51 0 001.59 2.75l43.88 25.32a1.1 1.1 0 00.53.15H457.2l.09-.06.09-.08a1.22 1.22 0 00.29-.42 1.88 1.88 0 00.17-.8v-76a3.5 3.5 0 00-1.59-2.75l-43.88-25.29a1.16 1.16 0 00-1.07-.14l-.13.08-.11.1a.21.21 0 000 .06.26.26 0 00-.05.09.54.54 0 00-.1.2.58.58 0 000 .14v.15c-.12-.01-.13.06-.13.12z"
                style={{
                  WebkitTransformOrigin: 434.31,
                  MsTransformOrigin: 434.31,
                  transformOrigin: 434.31,
                }}
                id="el2q9zqohikok"
                fill="#455A64"
                className="animable"
              ></path>
            </g>
            <path
              d="M411.3 149.24a1.16 1.16 0 011.07.14l43.88 25.29a3.5 3.5 0 011.59 2.75v5.18l2.53-1.46V176a3.48 3.48 0 00-1.59-2.74L414.9 148a1.11 1.11 0 00-1.15-.1c-.29.1-2.11 1.17-2.45 1.34z"
              style={{
                WebkitTransformOrigin: 435.835,
                MsTransformOrigin: 435.835,
                transformOrigin: 435.835,
              }}
              id="el53bpwx4vm7t"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M410.79 150.28c0-1 .71-1.4 1.58-.9l43.88 25.29a3.51 3.51 0 011.59 2.75v5.18l-47-27.11z"
              style={{
                WebkitTransformOrigin: 434.315,
                MsTransformOrigin: 434.315,
                transformOrigin: 434.315,
              }}
              id="elpdq7boghqi"
              fill="#8AC832"
              className="animable"
            ></path>
            <g
              style={{
                WebkitTransformOrigin: 435.6,
                MsTransformOrigin: 435.6,
                transformOrigin: 435.6,
              }}
              id="eldmrkjyl4rul"
              className="animable"
              opacity="0.5"
            >
              <path
                d="M412.37 149.38l43.88 25.29a3.27 3.27 0 011.12 1.18l2.52-1.45a3.23 3.23 0 00-1.11-1.15L414.9 148a1.11 1.11 0 00-1.15-.1c-.28.18-2.11 1.2-2.44 1.38a1.11 1.11 0 011.06.1z"
                style={{
                  WebkitTransformOrigin: 435.6,
                  MsTransformOrigin: 435.6,
                  transformOrigin: 435.6,
                }}
                id="el0iiuuex7beds"
                fill="#FFF"
                className="animable"
              ></path>
            </g>
            <path
              d="M460.37 181.15V176a3.36 3.36 0 00-.48-1.59l-2.53 1.44a3.16 3.16 0 01.48 1.58v5.18z"
              style={{
                WebkitTransformOrigin: 458.865,
                MsTransformOrigin: 458.865,
                transformOrigin: 458.865,
              }}
              id="elzw0gozl5q5"
              className="animable"
              opacity="0.15"
            ></path>
            <path
              d="M455.53 176.8a2.37 2.37 0 01.9 1.9c0 .76-.4 1.15-.9.86a2.36 2.36 0 01-.9-1.89c0-.77.37-1.15.9-.87z"
              style={{
                WebkitTransformOrigin: 455.53,
                MsTransformOrigin: 455.53,
                transformOrigin: 455.53,
              }}
              id="elqdrkcs26re"
              fill="#455A64"
              className="animable"
            ></path>
            <path
              d="M452.3 174.94a2.33 2.33 0 01.9 1.89c0 .77-.4 1.15-.9.87a2.39 2.39 0 01-.89-1.9c0-.8.4-1.15.89-.86z"
              style={{
                WebkitTransformOrigin: 452.305,
                MsTransformOrigin: 452.305,
                transformOrigin: 452.305,
              }}
              id="elonsi2xgxl9d"
              fill="#455A64"
              className="animable"
            ></path>
            <path
              d="M449.08 173.07A2.39 2.39 0 01450 175c0 .76-.4 1.15-.89.86a2.35 2.35 0 01-.9-1.9c-.03-.79.37-1.17.87-.89z"
              style={{
                WebkitTransformOrigin: 449.104,
                MsTransformOrigin: 449.104,
                transformOrigin: 449.104,
              }}
              id="elj5sip2tbadf"
              fill="#455A64"
              className="animable"
            ></path>
            <g
              style={{
                WebkitTransformOrigin: 458.8,
                MsTransformOrigin: 458.8,
                transformOrigin: 458.8,
              }}
              id="elrroju96mqx"
              className="animable"
              opacity="0.9"
            >
              <path
                d="M457.26 254.74l.19-.11.49-.28a1.74 1.74 0 01.26-.15l.42-.24.85-.48.2-.11a.9.9 0 00.27-.21 1.1 1.1 0 00.21-.33 1.89 1.89 0 00.19-.84v-70.85l-2.53 1.46v70.81a2.31 2.31 0 01-.17.8 1.22 1.22 0 01-.29.42.24.24 0 01-.09.08z"
                style={{
                  WebkitTransformOrigin: 458.8,
                  MsTransformOrigin: 458.8,
                  transformOrigin: 458.8,
                }}
                id="elf8ihlqsadal"
                fill="#37474F"
                className="animable"
              ></path>
            </g>
            <path
              d="M414.43 164.25a.25.25 0 01.08-.2l1.14-1h.05a.17.17 0 01.09.11.29.29 0 010 .16v.79a1.09 1.09 0 010 .22.83.83 0 01-.08.12l-.61.55.61 1.25c0 .08.06.15.08.22a1.44 1.44 0 010 .24v.91a.07.07 0 01-.09 0l-.05-.07-1.14-2.37a.67.67 0 01-.08-.29z"
              style={{
                WebkitTransformOrigin: 415.115,
                MsTransformOrigin: 415.115,
                transformOrigin: 415.115,
              }}
              id="elz4j82gq76jm"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M418.6 163.15a.3.3 0 01.09-.13h.17l.42.25a.17.17 0 01.09.11.29.29 0 010 .16.2.2 0 010 .07l-2 6.08a.26.26 0 01-.08.13h-.17l-.41-.24a.2.2 0 01-.09-.11.32.32 0 010-.16v-.07z"
              style={{
                WebkitTransformOrigin: 417.996,
                MsTransformOrigin: 417.996,
                transformOrigin: 417.996,
              }}
              id="el5ob0dyry8rp"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M421.63 169a.26.26 0 01-.08.21l-1.14 1a.07.07 0 01-.06 0 .2.2 0 01-.09-.11.32.32 0 010-.16v-.79a1 1 0 010-.22.35.35 0 01.08-.13l.6-.55-.6-1.24a2.11 2.11 0 01-.08-.22 1.44 1.44 0 010-.24v-.8a.12.12 0 010-.11h.09a.22.22 0 01.06.07l1.14 2.36a.67.67 0 01.08.3z"
              style={{
                WebkitTransformOrigin: 420.939,
                MsTransformOrigin: 420.939,
                transformOrigin: 420.939,
              }}
              id="el4d91tj1xbtq"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M424.8 172.11a.29.29 0 01.11.13.48.48 0 010 .2v.87a.18.18 0 010 .14.08.08 0 01-.11 0l-.54-.31a.29.29 0 01-.11-.13.49.49 0 010-.2V172a.21.21 0 010-.15.08.08 0 01.11 0z"
              style={{
                WebkitTransformOrigin: 424.53,
                MsTransformOrigin: 424.53,
                transformOrigin: 424.53,
              }}
              id="elza055t93q3"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M426.6 173.15a.29.29 0 01.11.13.48.48 0 010 .2v.87a.18.18 0 010 .14.09.09 0 01-.11 0l-.54-.31a.36.36 0 01-.11-.13.53.53 0 01-.05-.2V173a.21.21 0 01.05-.15.08.08 0 01.11 0z"
              style={{
                WebkitTransformOrigin: 426.312,
                MsTransformOrigin: 426.312,
                transformOrigin: 426.312,
              }}
              id="eldpbn0arerx"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M428.4 174.19a.25.25 0 01.11.13.48.48 0 010 .2v.87a.2.2 0 010 .14.09.09 0 01-.11 0l-.54-.31a.33.33 0 01-.11-.14.45.45 0 01-.05-.19V174a.2.2 0 01.05-.14.09.09 0 01.11 0z"
              style={{
                WebkitTransformOrigin: 428.111,
                MsTransformOrigin: 428.111,
                transformOrigin: 428.111,
              }}
              id="el7stdm0xxe2a"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M414.91 171.17l26.36 15.22a1.2 1.2 0 01.57.94c0 .34-.25.46-.57.28l-26.36-15.22a1.21 1.21 0 01-.56-.93c0-.34.25-.46.56-.29z"
              style={{
                WebkitTransformOrigin: 428.095,
                MsTransformOrigin: 428.095,
                transformOrigin: 428.095,
              }}
              id="ele2hds25hhfm"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M423.37 190.71l26.36 15.22a1.19 1.19 0 01.57.93c0 .34-.25.47-.57.29l-26.36-15.22a1.21 1.21 0 01-.56-.94c0-.34.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 436.555,
                MsTransformOrigin: 436.555,
                transformOrigin: 436.555,
              }}
              id="ela99jsbza85"
              fill="#E6E6E6"
              className="animable"
            ></path>
            <path
              d="M423.37 200.47l12.63 7.29a1.21 1.21 0 01.56.94c0 .34-.25.46-.56.28l-12.62-7.29a1.19 1.19 0 01-.56-.93c-.01-.34.24-.47.55-.29z"
              style={{
                WebkitTransformOrigin: 429.69,
                MsTransformOrigin: 429.69,
                transformOrigin: 429.69,
              }}
              id="elxnr47g81smi"
              fill="#E6E6E6"
              className="animable"
            ></path>
            <path
              d="M443.46 187.65l10.5 6a1.19 1.19 0 01.57.93c0 .34-.26.47-.57.29l-10.5-6a1.19 1.19 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 448.715,
                MsTransformOrigin: 448.715,
                transformOrigin: 448.715,
              }}
              id="elv5oaogpe3zb"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M414.91 224.89l26.36 15.22a1.19 1.19 0 01.57.93c0 .34-.25.47-.57.29l-26.36-15.22a1.21 1.21 0 01-.56-.94c0-.34.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 428.095,
                MsTransformOrigin: 428.095,
                transformOrigin: 428.095,
              }}
              id="elgy9jp76cybo"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M443.46 241.37l10.5 6a1.22 1.22 0 01.57.94c0 .33-.26.46-.57.28l-10.5-6a1.21 1.21 0 01-.56-.94c0-.33.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 448.715,
                MsTransformOrigin: 448.715,
                transformOrigin: 448.715,
              }}
              id="ely87sflhlvl9"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M443.46 226.74l10.5 6a1.2 1.2 0 01.57.93c0 .34-.26.47-.57.29l-10.5-6a1.21 1.21 0 01-.56-.94c0-.33.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 448.715,
                MsTransformOrigin: 448.715,
                transformOrigin: 448.715,
              }}
              id="elsd75ytv2hcd"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M443.46 231.63l10.5 6a1.22 1.22 0 01.57.93c0 .34-.26.47-.57.29l-10.5-6a1.21 1.21 0 01-.56-.94c0-.34.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 448.715,
                MsTransformOrigin: 448.715,
                transformOrigin: 448.715,
              }}
              id="el1uxbvcw8cje"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M434.5 221.56l5.9 3.41a1.18 1.18 0 01.57.93c0 .34-.25.47-.57.29l-5.9-3.41a1.21 1.21 0 01-.56-.94c0-.33.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 437.455,
                MsTransformOrigin: 437.455,
                transformOrigin: 437.455,
              }}
              id="elln3qwtdxyoq"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M414.91 176.07l15.38 8.87a1.21 1.21 0 01.56.93c0 .34-.25.47-.56.29l-15.38-8.87a1.21 1.21 0 01-.56-.94c0-.35.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 422.6,
                MsTransformOrigin: 422.6,
                transformOrigin: 422.6,
              }}
              id="eldl5c6xuhv1s"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M414.91 176.07l15.38 8.87a1.21 1.21 0 01.56.93c0 .34-.25.47-.56.29l-15.38-8.87a1.21 1.21 0 01-.56-.94c0-.35.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 422.6,
                MsTransformOrigin: 422.6,
                transformOrigin: 422.6,
              }}
              id="elfaxktwwxu07"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M414.91 180.94l5.22 3a1.21 1.21 0 01.56.93c0 .34-.25.47-.56.29l-5.22-3a1.21 1.21 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 417.52,
                MsTransformOrigin: 417.52,
                transformOrigin: 417.52,
              }}
              id="el9ajmobhy2h"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M414.91 180.94l5.22 3a1.21 1.21 0 01.56.93c0 .34-.25.47-.56.29l-5.22-3a1.21 1.21 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 417.52,
                MsTransformOrigin: 417.52,
                transformOrigin: 417.52,
              }}
              id="ellx8r784n9c"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M414.91 185.82l5.22 3a1.21 1.21 0 01.56.94c0 .33-.25.46-.56.28l-5.22-3a1.18 1.18 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 417.52,
                MsTransformOrigin: 417.52,
                transformOrigin: 417.52,
              }}
              id="elf6hyrstxcm6"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M414.91 185.82l5.22 3a1.21 1.21 0 01.56.94c0 .33-.25.46-.56.28l-5.22-3a1.18 1.18 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 417.52,
                MsTransformOrigin: 417.52,
                transformOrigin: 417.52,
              }}
              id="el83lb6oonf1b"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M414.91 190.71l5.22 3a1.19 1.19 0 01.56.93c0 .34-.25.47-.56.29l-5.22-3a1.21 1.21 0 01-.56-.94c0-.34.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 417.52,
                MsTransformOrigin: 417.52,
                transformOrigin: 417.52,
              }}
              id="els27vs6l7t1h"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M414.91 190.71l5.22 3a1.21 1.21 0 01.56.94c0 .34-.25.46-.56.28l-5.22-3a1.21 1.21 0 01-.56-.94c0-.34.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 417.52,
                MsTransformOrigin: 417.52,
                transformOrigin: 417.52,
              }}
              id="eli1tgr8tlp3"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M423.37 195.59l15.38 8.87a1.21 1.21 0 01.56.94c0 .33-.25.46-.56.28l-15.38-8.87a1.21 1.21 0 01-.56-.94c0-.33.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 431.06,
                MsTransformOrigin: 431.06,
                transformOrigin: 431.06,
              }}
              id="elc2vsw8qqeww"
              fill="#8AC832"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M440.93 205.72l6.69 3.88a1.18 1.18 0 01.56.93c0 .34-.25.47-.56.29l-6.69-3.88a1.21 1.21 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 444.275,
                MsTransformOrigin: 444.275,
                transformOrigin: 444.275,
              }}
              id="el9zd4t47n4ce"
              fill="#8AC832"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M423.37 195.59l15.38 8.87a1.21 1.21 0 01.56.94c0 .33-.25.46-.56.28l-15.38-8.87a1.21 1.21 0 01-.56-.94c0-.33.25-.46.56-.28z"
              style={{
                WebkitTransformOrigin: 431.06,
                MsTransformOrigin: 431.06,
                transformOrigin: 431.06,
              }}
              id="el7f574gan99s"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M440.93 205.72l6.69 3.88a1.18 1.18 0 01.56.93c0 .34-.25.47-.56.29l-6.69-3.88a1.21 1.21 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 444.275,
                MsTransformOrigin: 444.275,
                transformOrigin: 444.275,
              }}
              id="elbftlssxgfj"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M414.91 195.59l5.22 3a1.21 1.21 0 01.56.93c0 .34-.25.47-.56.29l-5.22-3a1.21 1.21 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 417.52,
                MsTransformOrigin: 417.52,
                transformOrigin: 417.52,
              }}
              id="elyygj1qecxys"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M414.91 195.59l5.22 3a1.21 1.21 0 01.56.93c0 .34-.25.47-.56.29l-5.22-3a1.21 1.21 0 01-.56-.93c0-.34.25-.47.56-.29z"
              style={{
                WebkitTransformOrigin: 417.52,
                MsTransformOrigin: 417.52,
                transformOrigin: 417.52,
              }}
              id="el6fxa43dmaov"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M432.47 186.2l6.69 3.87a1.21 1.21 0 01.56.94c0 .33-.25.46-.56.28l-6.69-3.87a1.21 1.21 0 01-.56-.94c0-.33.25-.48.56-.28z"
              style={{
                WebkitTransformOrigin: 435.815,
                MsTransformOrigin: 435.815,
                transformOrigin: 435.815,
              }}
              id="el9hqau2ctdb"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M432.47 186.2l6.69 3.87a1.21 1.21 0 01.56.94c0 .33-.25.46-.56.28l-6.69-3.87a1.21 1.21 0 01-.56-.94c0-.33.25-.48.56-.28z"
              style={{
                WebkitTransformOrigin: 435.815,
                MsTransformOrigin: 435.815,
                transformOrigin: 435.815,
              }}
              id="elmo4k48d8bhh"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M429.71 209l15.38 8.87a1.22 1.22 0 01.57.94c0 .34-.26.46-.57.29l-15.38-8.88a1.21 1.21 0 01-.56-.93c0-.29.25-.46.56-.29z"
              style={{
                WebkitTransformOrigin: 437.405,
                MsTransformOrigin: 437.405,
                transformOrigin: 437.405,
              }}
              id="elbmg6spenji9"
              fill="#FFF"
              className="animable"
            ></path>
            <path
              d="M438.59 219l15.41 8.91a1.22 1.22 0 01.57.94c0 .33-.26.46-.57.28l-15.37-8.87a1.2 1.2 0 01-.57-.94c-.06-.32.21-.46.53-.32z"
              style={{
                WebkitTransformOrigin: 446.311,
                MsTransformOrigin: 446.311,
                transformOrigin: 446.311,
              }}
              id="el398zysbcyuu"
              fill="#FFF"
              className="animable"
            ></path>
            <path
              d="M447.28 219.15L454 223a1.22 1.22 0 01.57.93c0 .34-.26.47-.57.29l-6.68-3.87a1.2 1.2 0 01-.57-.94c-.04-.32.25-.41.53-.26z"
              style={{
                WebkitTransformOrigin: 450.658,
                MsTransformOrigin: 450.658,
                transformOrigin: 450.658,
              }}
              id="elj71d2ihtq6"
              fill="#FFF"
              className="animable"
            ></path>
            <path
              d="M447.28 238.49l6.68 3.87a1.22 1.22 0 01.57.94c0 .33-.26.46-.57.28l-6.68-3.87a1.2 1.2 0 01-.57-.94c0-.33.29-.46.57-.28z"
              style={{
                WebkitTransformOrigin: 450.62,
                MsTransformOrigin: 450.62,
                transformOrigin: 450.62,
              }}
              id="el4krslncaxr3"
              fill="#E6E6E6"
              className="animable"
            ></path>
            <path
              d="M423.37 185.82l15.38 8.88a1.19 1.19 0 01.56.93c0 .34-.25.47-.56.29L423.37 187a1.18 1.18 0 01-.56-.93c0-.3.25-.43.56-.25z"
              style={{
                WebkitTransformOrigin: 431.06,
                MsTransformOrigin: 431.06,
                transformOrigin: 431.06,
              }}
              id="eltrk60yg7fx"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M423.37 185.82l15.38 8.88a1.19 1.19 0 01.56.93c0 .34-.25.47-.56.29L423.37 187a1.18 1.18 0 01-.56-.93c0-.3.25-.43.56-.25z"
              style={{
                WebkitTransformOrigin: 431.06,
                MsTransformOrigin: 431.06,
                transformOrigin: 431.06,
              }}
              id="ellg0rrpa5xjs"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
            <path
              d="M440.93 196l6.69 3.87a1.21 1.21 0 01.56.94c0 .33-.25.46-.56.28l-6.69-3.87a1.21 1.21 0 01-.56-.94c0-.38.25-.5.56-.28z"
              style={{
                WebkitTransformOrigin: 444.275,
                MsTransformOrigin: 444.275,
                transformOrigin: 444.275,
              }}
              id="elf791ri2olej"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M440.93 196l6.69 3.87a1.21 1.21 0 01.56.94c0 .33-.25.46-.56.28l-6.69-3.87a1.21 1.21 0 01-.56-.94c0-.38.25-.5.56-.28z"
              style={{
                WebkitTransformOrigin: 444.275,
                MsTransformOrigin: 444.275,
                transformOrigin: 444.275,
              }}
              id="eljij50c5xrr"
              fill="#FFF"
              className="animable"
              opacity="0.6"
            ></path>
          </g>
          <g
            id="freepik--Mouse--inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 353.701,
              MsTransformOrigin: 353.701,
              transformOrigin: 353.701,
            }}
          >
            <path
              d="M336.12 251.91l9.42 5.44a10.38 10.38 0 0010.4-.55l15.55-11.35c2.77-2 2.61-5-.36-6.77l-4.72-2.74a12.83 12.83 0 00-10.93-.33L336.29 246c-3.07 1.55-3.15 4.19-.17 5.91z"
              style={{
                WebkitTransformOrigin: 353.701,
                MsTransformOrigin: 353.701,
                transformOrigin: 353.701,
              }}
              id="elwgo4ofe6sc"
              className="animable"
              opacity="0.15"
            ></path>
            <path
              d="M371.74 240.51L361 248.92l-7.94 6.21a7 7 0 01-2.53.61 6.88 6.88 0 01-3.77-.79l-8.43-4.87h-.05a6 6 0 01-1.71-8.53l.25-.35a11.24 11.24 0 016.79-4.3l4.27-.85c6.92-1.41 12.59-2.09 13.25-1.64l10.57 6.12z"
              style={{
                WebkitTransformOrigin: 353.609,
                MsTransformOrigin: 353.609,
                transformOrigin: 353.609,
              }}
              id="els3iowf63ry"
              fill="#37474F"
              className="animable"
            ></path>
            <path
              d="M365.73 245.22l.61-.48-9.49-5.47 8.3-2.57-.84-.49-8.3 2.57-5.66-3.26-1.07.2z"
              style={{
                WebkitTransformOrigin: 357.81,
                MsTransformOrigin: 357.81,
                transformOrigin: 357.81,
              }}
              id="el69qpl0udbhb"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M354 254.62l7.56-5.46 10.19-7.36v-1.2a.1.1 0 00-.05-.09h-.06c-.76-.26-5.18 1.07-10.52 3.19l-3.54 1.41a11.21 11.21 0 00-7.1 10.47v.18a7 7 0 002.53-.61z"
              style={{
                WebkitTransformOrigin: 361.115,
                MsTransformOrigin: 361.115,
                transformOrigin: 361.115,
              }}
              id="el25uxdxqqstr"
              fill="#263238"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--Plant--inject-17"
        className="animable"
        style={{
          WebkitTransformOrigin: 394.539,
          MsTransformOrigin: 394.539,
          transformOrigin: 394.539,
        }}
      >
        <g
          id="freepik--Pot--inject-17"
          className="animable"
          style={{
            WebkitTransformOrigin: 394.539,
            MsTransformOrigin: 394.539,
            transformOrigin: 394.539,
          }}
        >
          <path
            d="M372.7 405.51c-10.38-10.71-16.47-54.29-6.35-62.78h51.5c10.12 8.49 4 52.06-6.34 62.77l-.29.3c-.11.12-.23.24-.35.35-.3.29-.61.57-.94.84l-.25.2c-.25.2-.5.4-.78.6a15.26 15.26 0 01-1.34.87c-8.54 5-22.38 5-30.92 0-.45-.26-.9-.56-1.35-.88-.26-.18-.49-.37-.73-.56l-.3-.24a12.15 12.15 0 01-.91-.81c-.14-.13-.28-.27-.41-.41a2.83 2.83 0 01-.24-.25z"
            style={{
              WebkitTransformOrigin: 392.097,
              MsTransformOrigin: 392.097,
              transformOrigin: 392.097,
            }}
            id="elkjopk58dr3"
            fill="#8AC832"
            className="animable"
          ></path>
          <g
            style={{
              WebkitTransformOrigin: 392.097,
              MsTransformOrigin: 392.097,
              transformOrigin: 392.097,
            }}
            id="elp17gcuqc988"
            className="animable"
            opacity="0.5"
          >
            <path
              d="M372.7 405.51c-10.38-10.71-16.47-54.29-6.35-62.78h51.5c10.12 8.49 4 52.06-6.34 62.77l-.29.3c-.11.12-.23.24-.35.35-.3.29-.61.57-.94.84l-.25.2c-.25.2-.5.4-.78.6a15.26 15.26 0 01-1.34.87c-8.54 5-22.38 5-30.92 0-.45-.26-.9-.56-1.35-.88-.26-.18-.49-.37-.73-.56l-.3-.24a12.15 12.15 0 01-.91-.81c-.14-.13-.28-.27-.41-.41a2.83 2.83 0 01-.24-.25z"
              style={{
                WebkitTransformOrigin: 392.097,
                MsTransformOrigin: 392.097,
                transformOrigin: 392.097,
              }}
              id="elwroz5d5a1cl"
              fill="#FFF"
              className="animable"
            ></path>
          </g>
          <path
            d="M413.38 339.31c11.75 6.86 11.75 18 0 24.85s-30.81 6.86-42.56 0-11.75-18 0-24.85 30.81-6.86 42.56 0z"
            style={{
              WebkitTransformOrigin: 392.1,
              MsTransformOrigin: 392.1,
              transformOrigin: 392.1,
            }}
            id="elto35yn2re2i"
            fill="#8AC832"
            className="animable"
          ></path>
          <g
            style={{
              WebkitTransformOrigin: 392.1,
              MsTransformOrigin: 392.1,
              transformOrigin: 392.1,
            }}
            id="elfsirhdlwj"
            className="animable"
            opacity="0.7"
          >
            <path
              d="M413.38 339.31c11.75 6.86 11.75 18 0 24.85s-30.81 6.86-42.56 0-11.75-18 0-24.85 30.81-6.86 42.56 0z"
              style={{
                WebkitTransformOrigin: 392.1,
                MsTransformOrigin: 392.1,
                transformOrigin: 392.1,
              }}
              id="el4wpqt5imhmp"
              fill="#FFF"
              className="animable"
            ></path>
          </g>
          <path
            d="M407.73 342.61c8.63 5 8.63 13.21 0 18.25s-22.63 5-31.26 0-8.63-13.21 0-18.25 22.63-5.04 31.26 0z"
            style={{
              WebkitTransformOrigin: 392.1,
              MsTransformOrigin: 392.1,
              transformOrigin: 392.1,
            }}
            id="elaioc526vgd"
            fill="#8AC832"
            className="animable"
          ></path>
          <g
            style={{
              WebkitTransformOrigin: 392.1,
              MsTransformOrigin: 392.1,
              transformOrigin: 392.1,
            }}
            id="eluhtc1muxh3o"
            className="animable"
            opacity="0.3"
          >
            <path
              id="elfco1g6olr34"
              d="M407.73 342.61c8.63 5 8.63 13.21 0 18.25s-22.63 5-31.26 0-8.63-13.21 0-18.25 22.63-5.04 31.26 0z"
              className="animable"
              style={{
                WebkitTransformOrigin: 392.1,
                MsTransformOrigin: 392.1,
                transformOrigin: 392.1,
              }}
            ></path>
          </g>
          <path
            d="M376.47 351.27c8.63-5 22.63-5 31.26 0a14.36 14.36 0 015.16 4.79 14.38 14.38 0 01-5.16 4.8c-8.63 5-22.63 5-31.26 0a14.5 14.5 0 01-5.17-4.8 14.48 14.48 0 015.17-4.79z"
            style={{
              WebkitTransformOrigin: 392.095,
              MsTransformOrigin: 392.095,
              transformOrigin: 392.095,
            }}
            id="el3kbxiqno2wh"
            fill="#F5F5F5"
            className="animable"
          ></path>
          <g
            id="freepik--Plants--inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 394.539,
              MsTransformOrigin: 394.539,
              transformOrigin: 394.539,
            }}
          >
            <path
              d="M387.88 329.28a14.43 14.43 0 01-1.31-3.76c-.58-3.14.2-6.73 2.74-8.67 1-.76 2.33-1.33 2.76-2.53a4.14 4.14 0 000-2.07c-.47-2.68-1.37-5.44-.63-8.05a9 9 0 015-5.36 27 27 0 017.27-1.9 11.77 11.77 0 003.85-1.1c1.44-.81 1.89-2.23 2.78-3.48a24.3 24.3 0 013.54-3.77c2.62-2.34 5.9-4.27 9.53-4.11 7.58.33 7.36 6.85 5.18 11.79s-2.76 6.55 2 11.7 4.74 11.5-.91 15-9.32 4-7.08 10.86c2 6.11 3.23 11.32-2.41 17.85-3.65 4.22-8.64 7.23-14.88 7A25.12 25.12 0 01398 357c-1.72-.85-.56-2.18-1.14-3.88l-3.74-10.92a81.09 81.09 0 00-3-8.62c-.69-1.5-1.53-2.87-2.24-4.3z"
              style={{
                WebkitTransformOrigin: 410.217,
                MsTransformOrigin: 410.217,
                transformOrigin: 410.217,
              }}
              id="eldamn9bzxoa"
              fill="#8AC832"
              className="animable"
            ></path>
            <g
              style={{
                WebkitTransformOrigin: 410.217,
                MsTransformOrigin: 410.217,
                transformOrigin: 410.217,
              }}
              id="elt1whbynldek"
              className="animable"
              opacity="0.25"
            >
              <path
                id="elbc2y1zkhe26"
                d="M387.88 329.28a14.43 14.43 0 01-1.31-3.76c-.58-3.14.2-6.73 2.74-8.67 1-.76 2.33-1.33 2.76-2.53a4.14 4.14 0 000-2.07c-.47-2.68-1.37-5.44-.63-8.05a9 9 0 015-5.36 27 27 0 017.27-1.9 11.77 11.77 0 003.85-1.1c1.44-.81 1.89-2.23 2.78-3.48a24.3 24.3 0 013.54-3.77c2.62-2.34 5.9-4.27 9.53-4.11 7.58.33 7.36 6.85 5.18 11.79s-2.76 6.55 2 11.7 4.74 11.5-.91 15-9.32 4-7.08 10.86c2 6.11 3.23 11.32-2.41 17.85-3.65 4.22-8.64 7.23-14.88 7A25.12 25.12 0 01398 357c-1.72-.85-.56-2.18-1.14-3.88l-3.74-10.92a81.09 81.09 0 00-3-8.62c-.69-1.5-1.53-2.87-2.24-4.3z"
                className="animable"
                style={{
                  WebkitTransformOrigin: 410.217,
                  MsTransformOrigin: 410.217,
                  transformOrigin: 410.217,
                }}
              ></path>
            </g>
            <path
              d="M398.18 357a.53.53 0 00.37-.53c-.32-37.42 20.31-59.76 20.52-60a.58.58 0 000-.8.56.56 0 00-.79 0c-.21.22-21.14 22.87-20.82 60.76a.55.55 0 00.56.56z"
              style={{
                WebkitTransformOrigin: 408.343,
                MsTransformOrigin: 408.343,
                transformOrigin: 408.343,
              }}
              id="elgv9vupuh727"
              fill="#FFF"
              className="animable"
            ></path>
            <path
              d="M404.18 322.17l.12-.05c6.71-4.23 18.68-7.38 18.8-7.41a.57.57 0 00.4-.69.55.55 0 00-.68-.4c-.5.13-12.26 3.22-19.11 7.54a.55.55 0 00-.18.77.55.55 0 00.65.24z"
              style={{
                WebkitTransformOrigin: 413.48,
                MsTransformOrigin: 413.48,
                transformOrigin: 413.48,
              }}
              id="el11c7lrudumpq"
              fill="#FFF"
              className="animable"
            ></path>
            <path
              d="M406.26 317a.57.57 0 00.31-.74 43.53 43.53 0 00-6.19-10.41.55.55 0 00-.79-.06.57.57 0 00-.06.79 42.89 42.89 0 016 10.11.55.55 0 00.73.31z"
              style={{
                WebkitTransformOrigin: 403.005,
                MsTransformOrigin: 403.005,
                transformOrigin: 403.005,
              }}
              id="elri9cmpd210f"
              fill="#FFF"
              className="animable"
            ></path>
            <path
              d="M392.92 361a31.45 31.45 0 01-16.43.6c-9.42-2-15.19-10.84-15.19-10.84s10.2-4.08 16.14-4.48a52.62 52.62 0 00-17.85.38s-5.46-2-4.43-11.24c0 0 5.14-3.79 17-2.3 0 0-5.92-4.23-16.31-5.48-.82 0 .29-12 1.28-17.35s3-4.52 7.2-4.06 16.81 3.32 18.4 6.4.05 10.94.05 10.94a18 18 0 003.46-10.28s4.73 1.73 7.26 4a16.82 16.82 0 014.52 5.66c-.59 4.21-2.57 10.64-5.35 14.23 0 0 6.26-4.05 7.69-11.49a26 26 0 015 14.65c-.14 9.41-4.36 16.4-12.44 20.66z"
              style={{
                WebkitTransformOrigin: 380.195,
                MsTransformOrigin: 380.195,
                transformOrigin: 380.195,
              }}
              id="el5u9z5izzk3g"
              fill="#8AC832"
              className="animable"
            ></path>
            <path
              d="M392.92 361a31.45 31.45 0 01-16.43.6c-9.42-2-15.19-10.84-15.19-10.84s10.2-4.08 16.14-4.48a52.62 52.62 0 00-17.85.38s-5.46-2-4.43-11.24c0 0 5.14-3.79 17-2.3 0 0-5.92-4.23-16.31-5.48-.82 0 .29-12 1.28-17.35s3-4.52 7.2-4.06 16.81 3.32 18.4 6.4.05 10.94.05 10.94a18 18 0 003.46-10.28s4.73 1.73 7.26 4a16.82 16.82 0 014.52 5.66c-.59 4.21-2.57 10.64-5.35 14.23 0 0 6.26-4.05 7.69-11.49a26 26 0 015 14.65c-.14 9.41-4.36 16.4-12.44 20.66z"
              style={{
                WebkitTransformOrigin: 380.195,
                MsTransformOrigin: 380.195,
                transformOrigin: 380.195,
              }}
              id="elh78kpuqmtml"
              className="animable"
              opacity="0.1"
            ></path>
            <path
              d="M394.17 360.19a.52.52 0 01-.34-.46c-1.43-17.86-21.41-45.75-30.24-51.35a.56.56 0 01-.17-.75.55.55 0 01.74-.17c9 5.69 29.29 34 30.73 52.18a.53.53 0 01-.49.58.45.45 0 01-.23-.03z"
              style={{
                WebkitTransformOrigin: 379.117,
                MsTransformOrigin: 379.117,
                transformOrigin: 379.117,
              }}
              id="elk3xqx11o6ll"
              fill="#FFF"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--Character--inject-17"
        className="animable"
        style={{
          WebkitTransformOrigin: 190.499,
          MsTransformOrigin: 190.499,
          transformOrigin: 190.499,
        }}
      >
        <g
          id="freepik--character--inject-17"
          className="animable"
          style={{
            WebkitTransformOrigin: 190.499,
            MsTransformOrigin: 190.499,
            transformOrigin: 190.499,
          }}
        >
          <path
            d="M213.49 349c0-.2-3.21-11.8-3.21-11.8s1.05 1.07 7.75-.7a38 38 0 007.29-3.06l1.91 8.48c1.79 3.26 7.71 1.76 14.19 1 1.09-.13 2.21-.31 3.33-.5h.07c3.5-.19 7 1.91 3.38 4.9s-9.65 4.11-15.18 5.11c-6.66 1.25-18.34 3.2-19.53-3.43z"
            style={{
              WebkitTransformOrigin: 230.004,
              MsTransformOrigin: 230.004,
              transformOrigin: 230.004,
            }}
            id="el619jk0tz1qb"
            fill="#FFA8A7"
            className="animable"
          ></path>
          <path
            d="M260 348a6.79 6.79 0 01.48 3.56c-.12 1.29-3.32 5.67-9 8.36s-12.62 2.86-15.88 3.8-6.26 2.81-10.11 3.75-7.66 1.44-11.52-1.11c-.71-1.09-1.49-3.62-1.27-3.87.7-.66 47.3-14.49 47.3-14.49z"
            style={{
              WebkitTransformOrigin: 236.601,
              MsTransformOrigin: 236.601,
              transformOrigin: 236.601,
            }}
            id="elezv63jwh1aw"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M228.25 343.08c2.48 1.71 7.62.52 13.17-.11 5.24-.6 11.13-2.44 14.69-1.2s6.53 5.42 1.72 10.79c-1.39 1.55-4.33 4.28-6.69 5.13-6 2.14-11.34 2.31-15.18 3.26-5 1.23-7.74 3.45-12.36 4-6 .7-9.78-.84-10.82-2.44s-2-14.49.57-14.22c0 0 1.08 4.17 10.87.12 4.27-1.79 4.2-4.41 4.03-5.33z"
            style={{
              WebkitTransformOrigin: 236.023,
              MsTransformOrigin: 236.023,
              transformOrigin: 236.023,
            }}
            id="elki7embjk00a"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M228.25 343.08c2.48 1.71 7.62.52 13.17-.11 5.24-.6 11.13-2.44 14.69-1.2s6.53 5.42 1.72 10.79c-1.39 1.55-4.33 4.28-6.69 5.13-6 2.14-11.34 2.31-15.18 3.26-5 1.23-7.74 3.45-12.36 4-6 .7-9.78-.84-10.82-2.44s-2-14.49.57-14.22c0 0 1.08 4.17 10.87.12 4.27-1.79 4.2-4.41 4.03-5.33z"
            style={{
              WebkitTransformOrigin: 236.023,
              MsTransformOrigin: 236.023,
              transformOrigin: 236.023,
            }}
            id="el6awcmrwu2ra"
            className="animable"
            opacity="0.4"
          ></path>
          <path
            d="M244.85 350s-.56-5.44-4.58-6.88a2.11 2.11 0 00-2.22.29s3.73.54 5 6.93c0 0 .19.42 1 .27.24-.06.84-.17.8-.61z"
            style={{
              WebkitTransformOrigin: 241.451,
              MsTransformOrigin: 241.451,
              transformOrigin: 241.451,
            }}
            id="elbyl7dvm84qq"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M234.62 343.82s0-.18.94-.35a1.68 1.68 0 011.11.12s3 1.3 3.56 7c0 0 0 .68-.93.87a.82.82 0 01-1.07-.56s-.62-5.99-3.61-7.08z"
            style={{
              WebkitTransformOrigin: 237.425,
              MsTransformOrigin: 237.425,
              transformOrigin: 237.425,
            }}
            id="elnnsqv0x84r"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M231.4 343.94s.17-.34.87-.34c.89 0 1.1.35 1.1.35s2.14 2.19 2.16 6.95c0 0 .09.8-1 .88s-1-.82-1-.82-.38-6.06-2.13-7.02z"
            style={{
              WebkitTransformOrigin: 233.466,
              MsTransformOrigin: 233.466,
              transformOrigin: 233.466,
            }}
            id="elrkbz5yn724"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M209.35 270.2c4.9 14.73 17.9 65.45 17.9 65.45s-8.46 7.6-17.64 4.14l-21.87-63.16z"
            style={{
              WebkitTransformOrigin: 207.495,
              MsTransformOrigin: 207.495,
              transformOrigin: 207.495,
            }}
            id="elxxjqhsrpw8d"
            fill="#37474F"
            className="animable"
          ></path>
          <path
            d="M247.14 365.4c-1-1.49-4.76-11.8-4.76-11.8s3.92 2.24 10.67.64c3.43-.82 6.64-4.54 6.64-4.54l2.88 9.91c1.7 3.31 7.21 2.22 13.71 1.64 1.09-.1 2.21-.26 3.34-.42h.07c3.5-.1 7 2.08 3.25 5s-9.74 3.88-15.3 4.74c-6.64 1.01-16.75.43-20.5-5.17z"
            style={{
              WebkitTransformOrigin: 263.467,
              MsTransformOrigin: 263.467,
              transformOrigin: 263.467,
            }}
            id="elmd3orvabe7"
            fill="#FFA8A7"
            className="animable"
          ></path>
          <path
            d="M297.56 365.09a7.31 7.31 0 01.43 3.84c-.17 1.38-3.72 6-9.84 8.73s-13.63 2.74-17.16 3.66-6.79 2.86-10.95 3.77-8.26 1.33-12.33-1.49c-.74-1.2-1.52-3.94-1.26-4.2.67-.69 51.11-14.31 51.11-14.31z"
            style={{
              WebkitTransformOrigin: 272.239,
              MsTransformOrigin: 272.239,
              transformOrigin: 272.239,
            }}
            id="elk1lecmg16ii"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M263.63 358.87a10.44 10.44 0 001.23.76 3.67 3.67 0 001.36.28 18.9 18.9 0 003.28.08c2.74-.13 5.47-.55 8.21-.79 5.63-.5 12-2.32 15.79-.9s7.25 6 1.94 11.61a26 26 0 01-7.1 5.39c-6.29 2.63-12.82 2.14-17 3.06-5.4 1.19-8.4 3.5-13.38 3.95-6.45.59-10.47-1.16-11.54-2.91-.6-1 .06-6-.74-9.95-.7-3.38-.52-5.68.7-5.53a6 6 0 00.94 1.2 4.51 4.51 0 001.43 1.13 11.29 11.29 0 002.42.81 14.29 14.29 0 004.49.62 2.18 2.18 0 001.22-.39 2.57 2.57 0 00.71-1.52c.1-.5.21-1 .31-1.5a2.1 2.1 0 01.28-.77 2 2 0 01.76-.61 6.56 6.56 0 002.46-1.87 5.78 5.78 0 00.72-2.32.57.57 0 01.16-.38c.18-.14.45 0 .65.11z"
            style={{
              WebkitTransformOrigin: 271.716,
              MsTransformOrigin: 271.716,
              transformOrigin: 271.716,
            }}
            id="elsjuelm2b37i"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M263.63 358.87a10.44 10.44 0 001.23.76 3.67 3.67 0 001.36.28 18.9 18.9 0 003.28.08c2.74-.13 5.47-.55 8.21-.79 5.63-.5 12-2.32 15.79-.9s7.25 6 1.94 11.61a26 26 0 01-7.1 5.39c-6.29 2.63-12.82 2.14-17 3.06-5.4 1.19-8.4 3.5-13.38 3.95-6.45.59-10.47-1.16-11.54-2.91-.6-1 .06-6-.74-9.95-.7-3.38-.52-5.68.7-5.53a6 6 0 00.94 1.2 4.51 4.51 0 001.43 1.13 11.29 11.29 0 002.42.81 14.29 14.29 0 004.49.62 2.18 2.18 0 001.22-.39 2.57 2.57 0 00.71-1.52c.1-.5.21-1 .31-1.5a2.1 2.1 0 01.28-.77 2 2 0 01.76-.61 6.56 6.56 0 002.46-1.87 5.78 5.78 0 00.72-2.32.57.57 0 01.16-.38c.18-.14.45 0 .65.11z"
            style={{
              WebkitTransformOrigin: 271.716,
              MsTransformOrigin: 271.716,
              transformOrigin: 271.716,
            }}
            id="elirmmxpt6am"
            className="animable"
            opacity="0.4"
          ></path>
          <path
            d="M281.2 366.83s-.46-5.86-4.74-7.51a2.28 2.28 0 00-2.39.25s4 .68 5.14 7.57c0 0 .2.46 1.08.32.29-.04.94-.14.91-.63z"
            style={{
              WebkitTransformOrigin: 277.636,
              MsTransformOrigin: 277.636,
              transformOrigin: 277.636,
            }}
            id="el87jxb58leqr"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M270.38 359.94s0-.2 1-.36a1.78 1.78 0 011.18.16s3.19 1.47 3.64 7.6c0 0 0 .73-1 .91a.89.89 0 01-1.14-.63s-.49-6.44-3.68-7.68z"
            style={{
              WebkitTransformOrigin: 273.29,
              MsTransformOrigin: 273.29,
              transformOrigin: 273.29,
            }}
            id="el9i1l681mua"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M266.92 360s.19-.36.95-.34c.95 0 1.16.4 1.16.4s2.24 2.41 2.14 7.51c0 0 .08.87-1.13.93s-1-.91-1-.91-.26-6.54-2.12-7.59z"
            style={{
              WebkitTransformOrigin: 269.047,
              MsTransformOrigin: 269.047,
              transformOrigin: 269.047,
            }}
            id="elys61n2kbn"
            fill="#FAFAFA"
            className="animable"
          ></path>
          <path
            d="M243.84 287.59c3.86 11.87 13.72 45.66 18.22 63 0 0-8.09 7.28-18.5 6.64l-25.09-65.06 10-6.18z"
            style={{
              WebkitTransformOrigin: 240.265,
              MsTransformOrigin: 240.265,
              transformOrigin: 240.265,
            }}
            id="ela7j916y91bm"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M161.23 450a1.63 1.63 0 001.63-1.63V343.81a1.63 1.63 0 00-3.26 0V448.4a1.63 1.63 0 001.63 1.6z"
            style={{
              WebkitTransformOrigin: 161.23,
              MsTransformOrigin: 161.23,
              transformOrigin: 161.23,
            }}
            id="elo2509y7ywcb"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M96.52 412a1.62 1.62 0 001.51-1l32.07-81.18a1.62 1.62 0 10-3-1.19L95 409.73a1.63 1.63 0 00.91 2.11 1.61 1.61 0 00.61.16z"
            style={{
              WebkitTransformOrigin: 112.58,
              MsTransformOrigin: 112.58,
              transformOrigin: 112.58,
            }}
            id="el5gql4rnrpt6"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M100.37 402.21a1.61 1.61 0 001.18-.51l59.68-63.15 59.57 62.88a1.63 1.63 0 002.36-2.24l-60.75-64.13a1.64 1.64 0 00-1.18-.51 1.63 1.63 0 00-1.18.51l-60.86 64.4a1.63 1.63 0 001.18 2.75z"
            style={{
              WebkitTransformOrigin: 161.143,
              MsTransformOrigin: 161.143,
              transformOrigin: 161.143,
            }}
            id="elvt5usyby5b"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M225.94 412a1.61 1.61 0 00.6-.12 1.63 1.63 0 00.91-2.11l-32.07-81.17a1.63 1.63 0 10-3 1.19l32.08 81.18a1.62 1.62 0 001.48 1.03z"
            style={{
              WebkitTransformOrigin: 209.864,
              MsTransformOrigin: 209.864,
              transformOrigin: 209.864,
            }}
            id="elwka4l1kj0yk"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            d="M226.72 307.94c1.17-6.56-4.17-11.68-14.23-18.47a238.45 238.45 0 00-29.13-16.37c-8.42-3.86-17-3.5-27.79 2-15 7.69-60 35-60 35s67.32 38 80.27 36.3 45.32-22.76 47.89-30.17 2.99-8.29 2.99-8.29z"
            style={{
              WebkitTransformOrigin: 161.225,
              MsTransformOrigin: 161.225,
              transformOrigin: 161.225,
            }}
            id="el3lthkym8vd8"
            fill="#8AC832"
            className="animable"
          ></path>
          <g
            style={{
              WebkitTransformOrigin: 161.225,
              MsTransformOrigin: 161.225,
              transformOrigin: 161.225,
            }}
            id="eliofjt4e9c6j"
            className="animable"
            opacity="0.4"
          >
            <path
              id="el6z57u9nn37"
              d="M226.72 307.94c1.17-6.56-4.17-11.68-14.23-18.47a238.45 238.45 0 00-29.13-16.37c-8.42-3.86-17-3.5-27.79 2-15 7.69-60 35-60 35s67.32 38 80.27 36.3 45.32-22.76 47.89-30.17 2.99-8.29 2.99-8.29z"
              className="animable"
              style={{
                WebkitTransformOrigin: 161.225,
                MsTransformOrigin: 161.225,
                transformOrigin: 161.225,
              }}
            ></path>
          </g>
          <path
            d="M169.35 338.43c9.66 8.75 19.76 1.22 35.74-9.15 18.09-11.73 21.63-21.34 21.63-21.34s0 7.2-1.35 10.57-4.27 7.2-17.31 16.19-22.49 13.49-31.26 15.16l-6.92-.95"
            style={{
              WebkitTransformOrigin: 198.035,
              MsTransformOrigin: 198.035,
              transformOrigin: 198.035,
            }}
            id="el281rcso1hbf"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M205.09 329.28c18.09-11.73 21.63-21.34 21.63-21.34s0 7.2-1.35 10.57-4.27 7.2-17.31 16.19-22.49 13.49-31.26 15.16l-6.92-.95-.53-10.48c9.65 8.75 19.76 1.22 35.74-9.15z"
            style={{
              WebkitTransformOrigin: 198.035,
              MsTransformOrigin: 198.035,
              transformOrigin: 198.035,
            }}
            id="eltmln2dxgofo"
            className="animable"
            opacity="0.5"
          ></path>
          <path
            d="M99 399.22l-5 11.42a1.59 1.59 0 00-.06.3 1.34 1.34 0 000 .21 1.41 1.41 0 00.63.76 3 3 0 002.68.13 1.18 1.18 0 00.55-.53v-.15l4.6-10.71z"
            style={{
              WebkitTransformOrigin: 98.1679,
              MsTransformOrigin: 98.1679,
              transformOrigin: 98.1679,
            }}
            id="elx9r88emo048"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M223.73 399.7l4.27 11.19a1.35 1.35 0 010 .29v.2a1.31 1.31 0 01-.64.7 2.8 2.8 0 01-2.58 0 1.15 1.15 0 01-.51-.52v-.16l-3.93-10.49z"
            style={{
              WebkitTransformOrigin: 224.174,
              MsTransformOrigin: 224.174,
              transformOrigin: 224.174,
            }}
            id="el0zprg8tmkbso"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M159.35 440.3v9.26a1 1 0 00.55.76 2.9 2.9 0 002.66 0 .93.93 0 00.54-.76v-9.26a4 4 0 00-3.75 0z"
            style={{
              WebkitTransformOrigin: 161.225,
              MsTransformOrigin: 161.225,
              transformOrigin: 161.225,
            }}
            id="el8tjfiud1pbe"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M122.54 268.72c3.83 4.47 38.72-5.57 48-6.83 14.9-2 27-3.51 32.1-1.92s7.21 4.17 8.76 10.23c1.83 7.14 2.77 10.79 2.77 10.79s-24.76 9.5-44.3 11.79-47.33-24.06-47.33-24.06z"
            style={{
              WebkitTransformOrigin: 168.355,
              MsTransformOrigin: 168.355,
              transformOrigin: 168.355,
            }}
            id="elf8t29vij12b"
            fill="#37474F"
            className="animable"
          ></path>
          <path
            d="M116 275.27c-3.87 14.74-7.34 31.88 1.61 41.26 6 6.32 36.31 22.74 55.85 16.27 19.24-6.37 59.1-36 63.1-38.93s7.63-5 7.25-6.28c-5.37-17.84-13.23-19.24-27.79-16-17.82 3.92-56.92 19.87-56.92 19.87z"
            style={{
              WebkitTransformOrigin: 177.905,
              MsTransformOrigin: 177.905,
              transformOrigin: 177.905,
            }}
            id="el9blx6jzb5qc"
            fill="#455A64"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 186.95,
              MsTransformOrigin: 186.95,
              transformOrigin: 186.95,
            }}
            id="elr8vgcwhkyi"
            fill="#FFA8A7"
            d="M204.52 180.52L191.08 195.71 169.38 185.41 184.55 164.42 204.52 180.52z"
            className="animable"
          ></path>
          <path
            d="M221.19 151.66s5.5 7.94 4.91 8.75-4.48 1.61-4.48 1.61z"
            style={{
              WebkitTransformOrigin: 223.667,
              MsTransformOrigin: 223.667,
              transformOrigin: 223.667,
            }}
            id="elgqo2q8vo7st"
            fill="#F28F8F"
            className="animable"
          ></path>
          <path
            d="M221.15 156.91a6.58 6.58 0 116.58-6.58 6.59 6.59 0 01-6.58 6.58zm0-11.95a5.37 5.37 0 105.37 5.37 5.38 5.38 0 00-5.37-5.33z"
            style={{
              WebkitTransformOrigin: 221.15,
              MsTransformOrigin: 221.15,
              transformOrigin: 221.15,
            }}
            id="el07r52s6b5258"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M205.92 129.68c10.81 2 14 6.68 15.43 23.75 1.46 17.83-.23 23.49-2.52 25.94-1.55 1.66-10.34 2.16-14.81 1-5.59-1.41-18.25-5.57-24.33-14.42-7.16-10.41-9.31-24.69-2-30.73 10.2-8.47 23.83-6.36 28.23-5.54z"
            style={{
              WebkitTransformOrigin: 197.524,
              MsTransformOrigin: 197.524,
              transformOrigin: 197.524,
            }}
            id="el5m3p2zcua04"
            fill="#FFA8A7"
            className="animable"
          ></path>
          <path
            d="M204.52 180.52c4.65 1 11.73.41 13.83-.79a16 16 0 01-7.83-.29 25.61 25.61 0 01-7.17-3.16z"
            style={{
              WebkitTransformOrigin: 210.85,
              MsTransformOrigin: 210.85,
              transformOrigin: 210.85,
            }}
            id="elzykma7yw4f"
            fill="#F28F8F"
            className="animable"
          ></path>
          <path
            d="M223.35 136.67c-3 2.08-6.7 2.94-10.32 3.51.28 2.89-.63 5.75-1.53 8.52-.62 1.91-2.87 7.92-5.32 4.62-1.77-2.38-3.37-4.55-6.76-4-5.58 1-6.17 8.11-2.54 12.37s6.88 2.52 6.88 2.52.51 7.69-3.55 13.13c0 0-6.05 3.72-14.55.92-5.36-1.77-13.1-8.53-15.95-13.81-7.85-14.52-7.89-28.44 1.63-32.72.88-7 6.27-10.2 12.46-11.77 8.59-2.18 17.51 3.21 25.81-.35 1.75-.75 3.36-1.81 5.15-2.46a3.56 3.56 0 013.09 0 3.76 3.76 0 011.32 2.36 6.62 6.62 0 01-.33 5 15 15 0 013.91-1.44 4.9 4.9 0 013.94.89 5.07 5.07 0 011.58 3.44c.31 3.67-1.92 7.18-4.92 9.27z"
            style={{
              WebkitTransformOrigin: 196.148,
              MsTransformOrigin: 196.148,
              transformOrigin: 196.148,
            }}
            id="ele98y6ejjspg"
            fill="#263238"
            className="animable"
          ></path>
          <path
            d="M171.19 134.12l-6.52-3.65a3.74 3.74 0 116.52 3.65z"
            style={{
              WebkitTransformOrigin: 168.212,
              MsTransformOrigin: 168.212,
              transformOrigin: 168.212,
            }}
            id="eluhfm01zfgl"
            fill="#263238"
            className="animable"
          ></path>
          <path
            style={{
              WebkitTransformOrigin: 216.6,
              MsTransformOrigin: 216.6,
              transformOrigin: 216.6,
            }}
            id="el9emrdykxw5"
            fill="#263238"
            d="M205.97 150.88H227.23V151.91H205.97z"
            className="animable"
            transform="rotate(-10.57)"
          ></path>
          <path
            d="M249.86 189.4c-.56-.94-1.81-1.13-2.85-1.49-1.92-.67-3.42-2.2-5.27-3a10.4 10.4 0 00-6.66-.45 16.88 16.88 0 00-2.22.71 27.94 27.94 0 00-4 2c-5.3 3.13-9.28 10.22-14.49 13.47-1.94 1.21-3.75 2.31-5.54 3.41l12.47 11.05a74.46 74.46 0 016.14-4.67c3.06-1.82 6.15-1.86 9.59-2.36a47.58 47.58 0 007-1.75 3.09 3.09 0 002.07-1.35 2.08 2.08 0 00-1.34-2.56 18 18 0 00-3.63-.5c-.9-.14-3.3.39-3.83-.51-.28-.48.07-1.06.41-1.49 2.16-2.69 4.89-5.57 8.34-6.38a7.24 7.24 0 003-1.21 2.39 2.39 0 00.81-2.92z"
            style={{
              WebkitTransformOrigin: 229.447,
              MsTransformOrigin: 229.447,
              transformOrigin: 229.447,
            }}
            id="elvsylbd2m7l"
            fill="#FFA8A7"
            className="animable"
          ></path>
          <path
            d="M175.47 177c-13.21-7.21-25.24-2.58-29.57 6.69-3.93 8.39-12.17 40.85-12.17 40.85C137.69 232 175.47 177 175.47 177z"
            style={{
              WebkitTransformOrigin: 154.6,
              MsTransformOrigin: 154.6,
              transformOrigin: 154.6,
            }}
            id="el66tq0qmn7vm"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M173.49 179.6l2-2.61c-14.92-7.08-28.27 2.22-40 20.52-12.68 19.72-19.33 48-19.39 77.91 0 0 2.53 13.43 19.49 20.14 18 7.13 43.11 4.11 50.94-14.55 0 0 .16-18.63 5.82-27.81 3.67-5.94 12.22-19.13 18.58-28.6 5.54-8.24 9.85-27-1.72-33.85a98.25 98.25 0 00-9.41-4.8c-10.58 3.48-27.67-2.17-26.31-6.35z"
            style={{
              WebkitTransformOrigin: 166.311,
              MsTransformOrigin: 166.311,
              transformOrigin: 166.311,
            }}
            id="el62x4dpaj7y8"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M173.53 179.67l1.94-2.68c-14.92-7.08-28.27 2.22-40 20.52-12.68 19.72-19.33 48-19.39 77.91 0 0 2.53 13.43 19.49 20.14 18 7.13 43.11 4.11 50.94-14.55 0 0 .16-18.63 5.82-27.81 3.67-5.94 12.22-19.13 18.58-28.6 5.54-8.24 9.85-27-1.72-33.85a98.25 98.25 0 00-9.41-4.8c-10.56 3.48-27.61-2.1-26.25-6.28z"
            style={{
              WebkitTransformOrigin: 166.291,
              MsTransformOrigin: 166.291,
              transformOrigin: 166.291,
            }}
            id="elu0mly5vu6zj"
            fill="#FFF"
            className="animable"
            opacity="0.75"
          ></path>
          <path
            d="M215.7 212.65a30.2 30.2 0 00.46-10.86A58 58 0 01204.9 219c-6.07 6.39-13.56 11.37-19.19 18.15-6 7.18-10.25 15.87-15.25 23.71-2 3.15-4.74 9.22-8.46 9.47-4.54.29-8.88-5.24-11.35-9.06-4-6.08-7.34-13.69-12.25-19-4.29-4.67-10.93-10.65-16.77-7.94-.44 1.55-.85 3.12-1.24 4.7s-.75 3.22-1.09 4.83v.19c-.33 1.62-.64 3.25-.93 4.88a2 2 0 010 .26q-.42 2.43-.75 4.86a157.64 157.64 0 00-1.49 21.41s2.53 13.43 19.49 20.14c18 7.13 43.11 4.11 50.94-14.55 0 0 .16-18.63 5.82-27.81.57-.92 1.27-2 2-3.27l.13-.21c.65-1 1.35-2.13 2.11-3.31 0-.07.09-.14.14-.21a.41.41 0 010-.09c1.62-2.53 3.44-5.33 5.32-8.22l.85-1.31c1.82-2.78 3.67-5.59 5.43-8.24.59-.89 1.17-1.76 1.75-2.61.24-.37.49-.73.72-1.09.2-.29.4-.61.59-.93l.18-.3.42-.74.18-.34.45-.88a2.4 2.4 0 01.11-.23c.19-.39.37-.79.55-1.2V219.94c.16-.38.32-.76.47-1.14 0-.1.07-.19.1-.28.14-.37.28-.74.41-1.11v-.22c.24-.69.46-1.41.66-2.13.2-.73.38-1.47.54-2.21v-.09z"
            style={{
              WebkitTransformOrigin: 166.29,
              MsTransformOrigin: 166.29,
              transformOrigin: 166.29,
            }}
            id="el3ubz6m8bnu2"
            fill="#8AC832"
            className="animable"
            opacity="0.1"
          ></path>
          <path
            d="M284.89 230.8a27.57 27.57 0 01-3.1 3.2c-4.56 4.13-9.89 6.12-16.09 10.14-5 3.25-12.73 8-19.24 12.05a97.27 97.27 0 01-21 9.68c-6 1.78-9.43 1.85-13-7.83-1.75-4.75-3.14-9.63-4.66-14.46q-3.37-10.79-6.64-21.61s-8-19.83 10-29.79c7.83 4.48 10.81 6.29 13.27 15.67 2.94 11.23 7.7 33.39 7.7 33.39a156.74 156.74 0 0018.59-7.92c2.28-1.13 5.09-1.92 6.72-3.95a30.18 30.18 0 002.86-4.46c.77-1.38 1.32-2.88 2.17-4.2a37.21 37.21 0 015.91-6.51 2.43 2.43 0 011.43-.85 1.66 1.66 0 011.45.88c.66 1.16.05 2.29-.29 3.47-.39 1.35-.78 2.7-1.16 4a35.25 35.25 0 0011.47-10.7 5.87 5.87 0 01.9-1.14 1.74 1.74 0 011.34-.49c1.2.15 2.39 2.09 2.45 3.2a18.23 18.23 0 00.09 3.39c.27 1 1 1.9 1.31 2.92a17 17 0 01.68 3.24 11.1 11.1 0 01-1.82 6.79 16 16 0 01-1.34 1.89z"
            style={{
              WebkitTransformOrigin: 243.729,
              MsTransformOrigin: 243.729,
              transformOrigin: 243.729,
            }}
            id="el6hvx1xot5xi"
            fill="#FFA8A7"
            className="animable"
          ></path>
          <path
            d="M210.08 191.35c6.85 2.77 11.79 5.9 14.91 16.36s6.52 27.29 6.52 27.29.06 3.51-8.26 8.42a20.48 20.48 0 01-16.11 2.17l-6.28-20.2s-11.14-27.06 9.22-34.04z"
            style={{
              WebkitTransformOrigin: 214.664,
              MsTransformOrigin: 214.664,
              transformOrigin: 214.664,
            }}
            id="el53f44g4tg7n"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M169.88 348.91c-5.5-.28-9.81-4.32-22.89-9.77-24.16-10.07-42.28-18.14-49.19-30.78s-11.79-49.18-10.06-65a20.35 20.35 0 011.18-5.24l-1.7-.25 4.4-3.75c4.52-3.68 11.86-.4 17.4 2.62 15.82 8.6 28.19 17 38 47.17 7.35 22.71 12.2 43.43 22.36 54.51"
            style={{
              WebkitTransformOrigin: 128.55,
              MsTransformOrigin: 128.55,
              transformOrigin: 128.55,
            }}
            id="el3j98891brsm"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M88.92 238.12l-1.7-.25 4.4-3.75c4.52-3.68 11.86-.4 17.4 2.62 15.82 8.6 28.19 17 38 47.17 7.35 22.71 12.2 43.43 22.36 54.51l.53 10.48c-5.5-.28-9.81-4.32-22.89-9.77-24.19-10.06-42.31-18.13-49.22-30.77s-11.79-49.18-10.06-65a20.78 20.78 0 011.18-5.24z"
            style={{
              WebkitTransformOrigin: 128.565,
              MsTransformOrigin: 128.565,
              transformOrigin: 128.565,
            }}
            id="elvtn7lgc5wir"
            className="animable"
            opacity="0.3"
          ></path>
          <path
            d="M104.44 240.64c15.81 8.6 28.18 17 38 47.17s15.13 56.88 34.4 62.05c0 0-8.71 3.47-35.41-7.83-8.5-3.59-18.81-10.14-25.58-13.94-13.27-7.45-21.32-13.55-22.59-15.84-7-12.59-11.79-49.18-10.07-65s13.32-10.93 21.25-6.61z"
            style={{
              WebkitTransformOrigin: 129.839,
              MsTransformOrigin: 129.839,
              transformOrigin: 129.839,
            }}
            id="eldn8oky1h6gs"
            fill="#8AC832"
            className="animable"
          ></path>
        </g>
      </g>
      <g
        id="freepik--speech-bubble--inject-17"
        className="animable"
        style={{
          WebkitTransformOrigin: 191.115,
          MsTransformOrigin: 191.115,
          transformOrigin: 191.115,
        }}
      >
        <g
          id="freepik--speech-bubble--inject-17"
          className="animable"
          style={{
            WebkitTransformOrigin: 191.115,
            MsTransformOrigin: 191.115,
            transformOrigin: 191.115,
          }}
        >
          <path
            d="M193.34 106.69L189 98.48l3.51-10.15v-6.21l-10.75 6.21v6.21l4.62 8a.62.62 0 00.32.28z"
            style={{
              WebkitTransformOrigin: 187.55,
              MsTransformOrigin: 187.55,
              transformOrigin: 187.55,
            }}
            id="ellxs29msov18"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M193.34 106.69L189 98.48l3.51-10.15v-6.21l-10.75 6.21v6.21l4.62 8a.62.62 0 00.32.28z"
            style={{
              WebkitTransformOrigin: 187.55,
              MsTransformOrigin: 187.55,
              transformOrigin: 187.55,
            }}
            id="elyf9rhh9erto"
            className="animable"
            opacity="0.2"
          ></path>
          <path
            d="M219 32.75a7.14 7.14 0 00-3.23-5.59l-2.62-1.51a7.12 7.12 0 00-6.45 0l-40.25 23.29a7.13 7.13 0 00-3.22 5.59v44.31a7.13 7.13 0 003.22 5.58l2.63 1.52a7.12 7.12 0 006.45 0l12.95-7.48 4.62 8a.68.68 0 001.24-.12l4.88-14.08 16.58-9.6a7.14 7.14 0 003.2-5.6z"
            style={{
              WebkitTransformOrigin: 191.115,
              MsTransformOrigin: 191.115,
              transformOrigin: 191.115,
            }}
            id="el6pb7dxwtvju"
            fill="#8AC832"
            className="animable"
          ></path>
          <path
            d="M163.23 98.84a7.13 7.13 0 003.22 5.58l2.63 1.52a7.21 7.21 0 005.9.26c-1.52.57-2.68-.28-2.68-2.12V59.77a6.64 6.64 0 01.95-3.18l-9.08-5.24a6.62 6.62 0 00-.94 3.18z"
            style={{
              WebkitTransformOrigin: 169.105,
              MsTransformOrigin: 169.105,
              transformOrigin: 169.105,
            }}
            id="elk6cdds695s"
            className="animable"
            opacity="0.2"
          ></path>
          <path
            d="M218.92 31.83c-.37-1.37-1.62-1.8-3.11-.95l-40.28 23.3a6.37 6.37 0 00-2.27 2.41l-9.08-5.24a6.58 6.58 0 012.27-2.4l40.27-23.3a7.12 7.12 0 016.45 0l2.64 1.52a7.08 7.08 0 013.11 4.66z"
            style={{
              WebkitTransformOrigin: 191.55,
              MsTransformOrigin: 191.55,
              transformOrigin: 191.55,
            }}
            id="elghqvgo1p7a9"
            fill="#FFF"
            className="animable"
            opacity="0.5"
          ></path>
          <g
            id="freepik----inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 195.814,
              MsTransformOrigin: 195.814,
              transformOrigin: 195.814,
            }}
          >
            <path
              d="M178.23 77.16a2.36 2.36 0 01.16-.92 7 7 0 01.47-.86l8.76-14.15a.66.66 0 01.14-.17l.1-.07a.24.24 0 01.32 0 .58.58 0 01.14.43v5.46a2.34 2.34 0 01-.26 1.14 7.16 7.16 0 01-.44.75l-4.52 6.88 4.52 2.08a1.92 1.92 0 01.44.21c.17.11.26.39.26.83v3.88a1.3 1.3 0 01-.14.58.83.83 0 01-.32.4h-.1a.23.23 0 01-.14 0l-8.76-4a1.18 1.18 0 01-.47-.32 1.17 1.17 0 01-.16-.73z"
              style={{
                WebkitTransformOrigin: 183.273,
                MsTransformOrigin: 183.273,
                transformOrigin: 183.273,
              }}
              id="el7ydby47ntxc"
              fill="#FFF"
              className="animable"
            ></path>
            <path
              d="M197.31 55.3a5.6 5.6 0 01.33-.88 1.59 1.59 0 01.64-.69l2.93-1.73a.26.26 0 01.34 0 .61.61 0 01.14.44 1.47 1.47 0 010 .33l-7.4 31.54a4.25 4.25 0 01-.31.85 1.59 1.59 0 01-.65.71l-2.87 1.66a.26.26 0 01-.34 0 .56.56 0 01-.14-.44 1.33 1.33 0 010-.32z"
              style={{
                WebkitTransformOrigin: 195.835,
                MsTransformOrigin: 195.835,
                transformOrigin: 195.835,
              }}
              id="elrimzr7st33h"
              fill="#FFF"
              className="animable"
            ></path>
            <path
              d="M213.4 60.4a2.3 2.3 0 01-.16.92 7 7 0 01-.47.86L204 76.34a1.31 1.31 0 01-.14.16l-.1.08a.25.25 0 01-.33 0 .55.55 0 01-.13-.43v-5.48a2.24 2.24 0 01.25-1.12c.17-.3.32-.54.45-.73l3.83-5.92-3.83-1.46a1.6 1.6 0 01-.45-.23c-.17-.12-.25-.4-.25-.85V54.9a1.33 1.33 0 01.13-.58.93.93 0 01.33-.39H204l8.76 4a.87.87 0 01.63 1z"
              style={{
                WebkitTransformOrigin: 208.35,
                MsTransformOrigin: 208.35,
                transformOrigin: 208.35,
              }}
              id="elsv2lheiv8k"
              fill="#FFF"
              className="animable"
            ></path>
          </g>
        </g>
      </g>
      <g
        id="freepik--text-boxes--inject-17"
        className="animable animator-hidden"
        style={{
          WebkitTransformOrigin: 73.555,
          MsTransformOrigin: 73.555,
          transformOrigin: 73.555,
        }}
      >
        <g
          id="freepik--text-box--inject-17"
          className="animable"
          style={{
            WebkitTransformOrigin: 73.555,
            MsTransformOrigin: 73.555,
            transformOrigin: 73.555,
          }}
        >
          <g
            id="freepik----inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 73.555,
              MsTransformOrigin: 73.555,
              transformOrigin: 73.555,
            }}
          >
            <g
              id="freepik--speech-bubble--inject-17"
              className="animable"
              style={{
                WebkitTransformOrigin: 73.555,
                MsTransformOrigin: 73.555,
                transformOrigin: 73.555,
              }}
            >
              <g
                id="freepik--speach-bubble--inject-17"
                className="animable"
                style={{
                  WebkitTransformOrigin: 73.555,
                  MsTransformOrigin: 73.555,
                  transformOrigin: 73.555,
                }}
              >
                <path
                  d="M96.5 27.2L42.61 58.25a2.94 2.94 0 00-1.34 2.31v30.09A2.92 2.92 0 0042.61 93l5.32 3a3 3 0 002.68 0l53.89-31a3 3 0 001.34-2.32V32.52a2.9 2.9 0 00-1.34-2.3l-5.32-3a3 3 0 00-2.68-.02z"
                  style={{
                    WebkitTransformOrigin: 73.555,
                    MsTransformOrigin: 73.555,
                    transformOrigin: 73.555,
                  }}
                  id="el26hpqggz2gp"
                  fill="#263238"
                  className="animable"
                ></path>
                <path
                  d="M105.82 32.28c-.1-.68-.65-.92-1.32-.54L50.62 62.79a2.77 2.77 0 00-.95 1l-8-4.59a2.63 2.63 0 01.92-1l53.89-31a3 3 0 012.68 0l5.32 3a3 3 0 011.34 2.08z"
                  style={{
                    WebkitTransformOrigin: 73.745,
                    MsTransformOrigin: 73.745,
                    transformOrigin: 73.745,
                  }}
                  id="el9toiah58an"
                  fill="#455A64"
                  className="animable"
                ></path>
                <path
                  d="M104.5 31.75l-53.89 31a3 3 0 00-1.33 2.32v30.12c0 .85.6 1.2 1.33.77l53.89-31a3 3 0 001.34-2.32V32.52c0-.85-.6-1.2-1.34-.77z"
                  style={{
                    WebkitTransformOrigin: 77.56,
                    MsTransformOrigin: 77.56,
                    transformOrigin: 77.56,
                  }}
                  id="elghex261lc8e"
                  fill="#37474F"
                  className="animable"
                ></path>
              </g>
            </g>
          </g>
          <path
            d="M62.6 70.5V75.03a5.86 5.86 0 00.15.97 1.7 1.7 0 00.38.76 1 1 0 00.65.3 1.86 1.86 0 001-.32 3.79 3.79 0 001-.77 4.52 4.52 0 001-1.76c.08-.3.15-.56.19-.8a3.45 3.45 0 01.19-.71.9.9 0 01.4-.4l2.19-1.3a.21.21 0 01.27 0 .49.49 0 01.11.35 10.35 10.35 0 01-.43 2.79 12.7 12.7 0 01-1.13 2.72 13.44 13.44 0 01-1.7 2.37A8.72 8.72 0 0164.76 81a4.47 4.47 0 01-2.21.71 2.53 2.53 0 01-1.66-.59 3.72 3.72 0 01-1.06-1.68 9.48 9.48 0 01-.42-2.53V74.6v-2.4a13.78 13.78 0 01.41-3 14.74 14.74 0 011.06-2.9 12.28 12.28 0 011.66-2.51 8.62 8.62 0 012.22-1.85 4.69 4.69 0 012.11-.7 2.84 2.84 0 011.7.41 3 3 0 011.13 1.41 5.85 5.85 0 01.43 2.29 1.2 1.2 0 01-.11.48.71.71 0 01-.27.33l-2.25 1.3c-.2.11-.33.13-.4.05a1.13 1.13 0 01-.19-.48 3.56 3.56 0 00-.19-.58 1.07 1.07 0 00-.37-.46 1.08 1.08 0 00-.62-.16 2.16 2.16 0 00-1 .35 3.54 3.54 0 00-1 .81 4.79 4.79 0 00-.65 1.06 5.41 5.41 0 00-.38 1.2 8.71 8.71 0 00-.1 1.25z"
            style={{
              WebkitTransformOrigin: 64.7708,
              MsTransformOrigin: 64.7708,
              transformOrigin: 64.7708,
            }}
            id="el3zptiddp4q8"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M77.24 54.73a4.57 4.57 0 012-.67 2.83 2.83 0 011.59.34 2.57 2.57 0 011.05 1.09A3.52 3.52 0 0182.3 57a1.2 1.2 0 01-.11.48.69.69 0 01-.25.31l-2.26 1.31a.61.61 0 01-.39.11.67.67 0 01-.3-.14l-.16-.17a.77.77 0 00-.32-.2 1.2 1.2 0 00-.52 0 2.06 2.06 0 00-.75.29 5.39 5.39 0 00-.63.43 3.74 3.74 0 00-.53.52 2.52 2.52 0 00-.38.63 1.86 1.86 0 00-.15.75.83.83 0 00.17.57.74.74 0 00.55.17 4.33 4.33 0 001-.16l1.58-.41a5.17 5.17 0 011.65-.21 1.94 1.94 0 011.18.45 2.41 2.41 0 01.71 1.18 7.43 7.43 0 01.23 2 9 9 0 01-.39 2.64A11.32 11.32 0 0181.14 70a10.86 10.86 0 01-1.69 2.12 10.39 10.39 0 01-2.13 1.63 5.16 5.16 0 01-2.13.75 2.79 2.79 0 01-1.66-.3 2.54 2.54 0 01-1.09-1.13 3.85 3.85 0 01-.44-1.73 1.07 1.07 0 01.12-.48.65.65 0 01.25-.32l2.25-1.3a.7.7 0 01.38-.12.54.54 0 01.27.12 2.39 2.39 0 01.21.22 1.2 1.2 0 00.37.28 1.14 1.14 0 00.58.1 2 2 0 00.87-.32 6.46 6.46 0 001.53-1.18 2.14 2.14 0 00.61-1.46.57.57 0 00-.23-.53 1.17 1.17 0 00-.67-.1 6.55 6.55 0 00-1.14.22c-.47.13-1 .27-1.64.42a2.48 2.48 0 01-2.59-.45 4.7 4.7 0 01-.82-3.17 9.14 9.14 0 01.33-2.37 11.14 11.14 0 011-2.39 10.37 10.37 0 011.54-2.14 8.55 8.55 0 012.02-1.64z"
            style={{
              WebkitTransformOrigin: 77.3109,
              MsTransformOrigin: 77.3109,
              transformOrigin: 77.3109,
            }}
            id="elcuaadifgo45"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M89.7 47.54a4.56 4.56 0 012-.68 3 3 0 011.59.34 2.69 2.69 0 011 1.09 3.56 3.56 0 01.4 1.55 1.07 1.07 0 01-.12.48.62.62 0 01-.25.31l-2.25 1.3a.63.63 0 01-.39.12.62.62 0 01-.3-.14l-.16-.17a.84.84 0 00-.32-.2 1.06 1.06 0 00-.52 0 2 2 0 00-.75.29 5.39 5.39 0 00-.63.43 3.8 3.8 0 00-.54.52 2.48 2.48 0 00-.37.63 1.86 1.86 0 00-.15.75.78.78 0 00.16.56.73.73 0 00.55.18 4.32 4.32 0 001-.16l1.58-.41a5.17 5.17 0 011.77-.26 2 2 0 011.18.44 2.45 2.45 0 01.71 1.19 7.43 7.43 0 01.23 2 8.76 8.76 0 01-.4 2.64 10.44 10.44 0 01-1.11 2.46 11 11 0 01-1.68 2.12 10.76 10.76 0 01-2.13 1.63 5.16 5.16 0 01-2.13.75A3 3 0 0186 67a2.59 2.59 0 01-1.09-1.13 3.74 3.74 0 01-.42-1.75 1 1 0 01.12-.47.65.65 0 01.24-.32l2.26-1.3a.85.85 0 01.38-.13.54.54 0 01.27.12 2.88 2.88 0 01.21.23 1.08 1.08 0 00.37.27 1 1 0 00.58.1 2 2 0 00.87-.31 6.49 6.49 0 001.53-1.19 2.1 2.1 0 00.61-1.45.57.57 0 00-.23-.53 1.09 1.09 0 00-.67-.1 5.72 5.72 0 00-1.14.22q-.7.19-1.65.42a2.51 2.51 0 01-2.59-.45 4.78 4.78 0 01-.81-3.17 9.14 9.14 0 01.33-2.37 11.14 11.14 0 011-2.39 10.71 10.71 0 011.54-2.15 8.51 8.51 0 011.99-1.61z"
            style={{
              WebkitTransformOrigin: 89.8058,
              MsTransformOrigin: 89.8058,
              transformOrigin: 89.8058,
            }}
            id="el6lk5j3q3i83"
            fill="#F0F0F0"
            className="animable"
          ></path>
        </g>
        <g
          id="freepik--text-box--inject-17"
          className="animable"
          style={{
            WebkitTransformOrigin: 73.555,
            MsTransformOrigin: 73.555,
            transformOrigin: 73.555,
          }}
        >
          <g
            id="freepik----inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 73.555,
              MsTransformOrigin: 73.555,
              transformOrigin: 73.555,
            }}
          >
            <g
              id="freepik--speech-bubble--inject-17"
              className="animable"
              style={{
                WebkitTransformOrigin: 73.555,
                MsTransformOrigin: 73.555,
                transformOrigin: 73.555,
              }}
            >
              <g
                id="freepik--speach-bubble--inject-17"
                className="animable"
                style={{
                  WebkitTransformOrigin: 73.555,
                  MsTransformOrigin: 73.555,
                  transformOrigin: 73.555,
                }}
              >
                <path
                  d="M96.5 89.72l-53.89 31a3 3 0 00-1.34 2.32v30.08a2.92 2.92 0 001.34 2.3l5.32 3a3 3 0 002.68 0l53.89-31a3 3 0 001.34-2.32V95a2.92 2.92 0 00-1.34-2.3l-5.32-3a3 3 0 00-2.68.02z"
                  style={{
                    WebkitTransformOrigin: 73.555,
                    MsTransformOrigin: 73.555,
                    transformOrigin: 73.555,
                  }}
                  id="elamwzxe1l8r"
                  fill="#263238"
                  className="animable"
                ></path>
                <path
                  d="M105.82 94.79c-.1-.67-.65-.91-1.32-.53l-53.88 31a2.77 2.77 0 00-.95 1l-8-4.59a2.63 2.63 0 01.92-.95l53.89-31a3 3 0 012.68 0l5.32 3a2.92 2.92 0 011.34 2.07z"
                  style={{
                    WebkitTransformOrigin: 73.745,
                    MsTransformOrigin: 73.745,
                    transformOrigin: 73.745,
                  }}
                  id="elx4owc5bdc8k"
                  fill="#455A64"
                  className="animable"
                ></path>
                <path
                  d="M104.5 94.26l-53.89 31a3 3 0 00-1.33 2.32v30.12c0 .85.6 1.2 1.33.77l53.89-31a3 3 0 001.34-2.32V95c0-.82-.6-1.17-1.34-.74z"
                  style={{
                    WebkitTransformOrigin: 77.56,
                    MsTransformOrigin: 77.56,
                    transformOrigin: 77.56,
                  }}
                  id="el5ohdlroliw6"
                  fill="#37474F"
                  className="animable"
                ></path>
              </g>
            </g>
          </g>
          <path
            d="M62.85 125.82a.25.25 0 01.33 0 .58.58 0 01.14.43v17.11a1.37 1.37 0 01-.14.58.8.8 0 01-.33.4l-2.25 1.3a.24.24 0 01-.33 0 .57.57 0 01-.14-.42v-6.49l-3.82 2.2v6.49a1.4 1.4 0 01-.13.59 1 1 0 01-.33.4l-2.25 1.3a.27.27 0 01-.33 0 .58.58 0 01-.14-.44v-17.12a1.42 1.42 0 01.14-.59.9.9 0 01.33-.4l2.25-1.3a.26.26 0 01.33 0 .56.56 0 01.13.42v6.38l3.82-2.2v-6.36a1.41 1.41 0 01.14-.58.85.85 0 01.33-.4z"
            style={{
              WebkitTransformOrigin: 58.2246,
              MsTransformOrigin: 58.2246,
              transformOrigin: 58.2246,
            }}
            id="elkn20lxyh18"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M75.43 118.56a.24.24 0 01.33 0 .57.57 0 01.14.42v2.81a1.34 1.34 0 01-.14.58.88.88 0 01-.33.41l-3 1.74v13.59a1.4 1.4 0 01-.13.59 1.05 1.05 0 01-.33.4l-2.25 1.3a.27.27 0 01-.33 0 .58.58 0 01-.14-.43v-13.59l-3 1.75a.26.26 0 01-.33 0 .58.58 0 01-.13-.43v-2.8a1.4 1.4 0 01.13-.59.91.91 0 01.33-.4z"
            style={{
              WebkitTransformOrigin: 70.8443,
              MsTransformOrigin: 70.8443,
              transformOrigin: 70.8443,
            }}
            id="el03t2wtex2hwc"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M83.34 127.86a1.13 1.13 0 01-.24-.3l-1.61-3.44v8.77a1.37 1.37 0 01-.14.58.8.8 0 01-.33.4l-2.25 1.3a.24.24 0 01-.33 0 .57.57 0 01-.14-.42v-17.14a1.37 1.37 0 01.14-.58.85.85 0 01.33-.4l2-1.15c.22-.14.4-.14.51 0a1.71 1.71 0 01.23.3l2.78 5.72 2.79-8.94a5.88 5.88 0 01.22-.56 1.3 1.3 0 01.52-.59l2-1.15a.25.25 0 01.32 0 .58.58 0 01.14.43v17.11a1.42 1.42 0 01-.14.59 1 1 0 01-.32.4l-2.26 1.3a.26.26 0 01-.33 0 .54.54 0 01-.13-.42v-8.77l-1.62 5.31a5.67 5.67 0 01-.23.57 1 1 0 01-.41.46l-1.1.63c-.17.13-.3.13-.4-.01z"
            style={{
              WebkitTransformOrigin: 84.2902,
              MsTransformOrigin: 84.2902,
              transformOrigin: 84.2902,
            }}
            id="elvbrpcp6hbqb"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M102 117.53a.25.25 0 01.33 0 .56.56 0 01.14.42v2.81a1.37 1.37 0 01-.14.58.8.8 0 01-.33.4l-8 4.6a.25.25 0 01-.33 0 .57.57 0 01-.14-.42v-17.11a1.37 1.37 0 01.14-.58.8.8 0 01.33-.4l2.25-1.3a.24.24 0 01.33 0 .57.57 0 01.13.42v13.59z"
            style={{
              WebkitTransformOrigin: 98.0002,
              MsTransformOrigin: 98.0002,
              transformOrigin: 98.0002,
            }}
            id="elctglfnadoyt"
            fill="#F0F0F0"
            className="animable"
          ></path>
        </g>
        <g
          id="freepik--text-box--inject-17"
          className="animable"
          style={{
            WebkitTransformOrigin: 73.555,
            MsTransformOrigin: 73.555,
            transformOrigin: 73.555,
          }}
        >
          <g
            id="freepik----inject-17"
            className="animable"
            style={{
              WebkitTransformOrigin: 73.555,
              MsTransformOrigin: 73.555,
              transformOrigin: 73.555,
            }}
          >
            <g
              id="freepik--speech-bubble--inject-17"
              className="animable"
              style={{
                WebkitTransformOrigin: 73.555,
                MsTransformOrigin: 73.555,
                transformOrigin: 73.555,
              }}
            >
              <g
                id="freepik--speach-bubble--inject-17"
                className="animable"
                style={{
                  WebkitTransformOrigin: 73.555,
                  MsTransformOrigin: 73.555,
                  transformOrigin: 73.555,
                }}
              >
                <path
                  d="M96.5 152.23l-53.89 31.05a2.94 2.94 0 00-1.34 2.31v30.08a2.89 2.89 0 001.34 2.3l5.32 3a3 3 0 002.68 0l53.89-31.05a2.94 2.94 0 001.34-2.31v-30.06a2.92 2.92 0 00-1.34-2.31l-5.32-3a3 3 0 00-2.68-.01z"
                  style={{
                    WebkitTransformOrigin: 73.555,
                    MsTransformOrigin: 73.555,
                    transformOrigin: 73.555,
                  }}
                  id="elqepjizu3ion"
                  fill="#263238"
                  className="animable"
                ></path>
                <path
                  d="M105.82 157.3c-.1-.67-.65-.91-1.32-.53l-53.88 31a2.7 2.7 0 00-.95 1l-8-4.59a2.66 2.66 0 01.92-1l53.89-31a3 3 0 012.68 0l5.32 3a2.94 2.94 0 011.34 2.12z"
                  style={{
                    WebkitTransformOrigin: 73.745,
                    MsTransformOrigin: 73.745,
                    transformOrigin: 73.745,
                  }}
                  id="elvnjt44cy9bs"
                  fill="#455A64"
                  className="animable"
                ></path>
                <path
                  d="M104.5 156.77l-53.89 31a3 3 0 00-1.33 2.31v30.08c0 .86.6 1.2 1.33.78l53.89-31.05a2.94 2.94 0 001.34-2.31v-30.03c0-.86-.6-1.2-1.34-.78z"
                  style={{
                    WebkitTransformOrigin: 77.56,
                    MsTransformOrigin: 77.56,
                    transformOrigin: 77.56,
                  }}
                  id="elqt50r0btgr"
                  fill="#37474F"
                  className="animable"
                ></path>
              </g>
            </g>
          </g>
          <path
            d="M63.64 194.92V199.45a6.49 6.49 0 00.16 1.08 1.7 1.7 0 00.38.76 1 1 0 00.65.3 1.86 1.86 0 001-.32 4 4 0 001-.76 5.44 5.44 0 00.62-.88 4.53 4.53 0 00.37-.89 8.22 8.22 0 00.19-.8 3.45 3.45 0 01.19-.71 1 1 0 01.4-.4l2.25-1.3a.21.21 0 01.27 0 .49.49 0 01.11.35 10.35 10.35 0 01-.43 2.79 12.24 12.24 0 01-1.14 2.72 12.9 12.9 0 01-1.69 2.37 8.49 8.49 0 01-2.11 1.73 4.37 4.37 0 01-2.21.71 2.53 2.53 0 01-1.66-.59 3.72 3.72 0 01-1.06-1.68 9.41 9.41 0 01-.42-2.53v-2.31-2.4a13.78 13.78 0 01.41-3 14.74 14.74 0 011.06-2.9 12.28 12.28 0 011.66-2.51 8.82 8.82 0 012.22-1.85 4.69 4.69 0 012.11-.7 2.86 2.86 0 011.69.41 3 3 0 011.14 1.41 5.86 5.86 0 01.43 2.3 1.19 1.19 0 01-.11.47.71.71 0 01-.27.33l-2.25 1.3c-.2.11-.33.13-.4.06a1.25 1.25 0 01-.19-.49 3.56 3.56 0 00-.19-.58 1.13 1.13 0 00-.37-.46 1.1 1.1 0 00-.62-.16 2.16 2.16 0 00-1 .35 3.54 3.54 0 00-1 .81 5 5 0 00-.65 1.06 5.41 5.41 0 00-.38 1.2 10.42 10.42 0 00-.16 1.18z"
            style={{
              WebkitTransformOrigin: 65.8708,
              MsTransformOrigin: 65.8708,
              transformOrigin: 65.8708,
            }}
            id="elu9aaqw8b12"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M79.44 191.39v4.37a1.42 1.42 0 01-.14.59 1 1 0 01-.32.4L76.81 198a.27.27 0 01-.33 0 .58.58 0 01-.14-.43v-4.37l-2.66 1.54a.25.25 0 01-.33 0 .58.58 0 01-.14-.43v-2.71a1.34 1.34 0 01.14-.58.88.88 0 01.33-.41l2.66-1.54v-4.37a1.37 1.37 0 01.14-.58.85.85 0 01.33-.4l2.19-1.25a.24.24 0 01.32 0 .57.57 0 01.14.42v4.38l2.65-1.53a.24.24 0 01.33 0 .57.57 0 01.14.42v2.68a1.37 1.37 0 01-.14.58.8.8 0 01-.33.4z"
            style={{
              WebkitTransformOrigin: 77.8948,
              MsTransformOrigin: 77.8948,
              transformOrigin: 77.8948,
            }}
            id="elgngantu9wmm"
            fill="#F0F0F0"
            className="animable"
          ></path>
          <path
            d="M90.85 184.81v4.37a1.41 1.41 0 01-.14.58.85.85 0 01-.33.4l-2.16 1.25a.25.25 0 01-.33 0 .57.57 0 01-.14-.42v-4.38l-2.67 1.54a.23.23 0 01-.32 0 .57.57 0 01-.14-.42V185a1.37 1.37 0 01.14-.58.84.84 0 01.32-.4l2.67-1.54v-4.37a1.42 1.42 0 01.14-.59.9.9 0 01.33-.4l2.16-1.25a.27.27 0 01.33 0 .58.58 0 01.14.43v4.37l2.65-1.53a.26.26 0 01.33 0 .58.58 0 01.13.43v2.67a1.33 1.33 0 01-.13.58.86.86 0 01-.33.4z"
            style={{
              WebkitTransformOrigin: 89.2907,
              MsTransformOrigin: 89.2907,
              transformOrigin: 89.2907,
            }}
            id="elmrlun5pt7yc"
            fill="#F0F0F0"
            className="animable"
          ></path>
        </g>
      </g>
      <defs>
        <filter id="active" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood
            floodColor="#32DFEC"
            floodOpacity="1"
            result="PINK"
          ></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <filter id="hover" height="200%">
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius="2"
            result="DILATED"
          ></feMorphology>
          <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
          <feComposite
            in="PINK"
            in2="DILATED"
            operator="in"
            result="OUTLINE"
          ></feComposite>
          <feMerge>
            <feMergeNode in="OUTLINE"></feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
          <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;